export default function () {
  return [
    {
      content: '北京市',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '北京城区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东城区',

              levelNumber: 3
            },
            {
              content: '西城区',

              levelNumber: 3
            },
            {
              content: '朝阳区',

              levelNumber: 3
            },
            {
              content: '丰台区',

              levelNumber: 3
            },
            {
              content: '石景山区',

              levelNumber: 3
            },
            {
              content: '海淀区',

              levelNumber: 3
            },
            {
              content: '门头沟区',

              levelNumber: 3
            },
            {
              content: '房山区',

              levelNumber: 3
            },
            {
              content: '通州区',

              levelNumber: 3
            },
            {
              content: '顺义区',

              levelNumber: 3
            },
            {
              content: '昌平区',

              levelNumber: 3
            },
            {
              content: '大兴区',

              levelNumber: 3
            },
            {
              content: '怀柔区',

              levelNumber: 3
            },
            {
              content: '平谷区',

              levelNumber: 3
            },
            {
              content: '密云区',

              levelNumber: 3
            },
            {
              content: '延庆区',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '天津市',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '天津城区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '和平区',

              levelNumber: 3
            },
            {
              content: '河东区',

              levelNumber: 3
            },
            {
              content: '河西区',

              levelNumber: 3
            },
            {
              content: '南开区',

              levelNumber: 3
            },
            {
              content: '河北区',

              levelNumber: 3
            },
            {
              content: '红桥区',

              levelNumber: 3
            },
            {
              content: '东丽区',

              levelNumber: 3
            },
            {
              content: '西青区',

              levelNumber: 3
            },
            {
              content: '津南区',

              levelNumber: 3
            },
            {
              content: '北辰区',

              levelNumber: 3
            },
            {
              content: '武清区',

              levelNumber: 3
            },
            {
              content: '宝坻区',

              levelNumber: 3
            },
            {
              content: '滨海新区',

              levelNumber: 3
            },
            {
              content: '宁河区',

              levelNumber: 3
            },
            {
              content: '静海区',

              levelNumber: 3
            },
            {
              content: '蓟州区',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '河北省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '石家庄市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '长安区',

              levelNumber: 3
            },
            {
              content: '桥西区',

              levelNumber: 3
            },
            {
              content: '新华区',

              levelNumber: 3
            },
            {
              content: '井陉矿区',

              levelNumber: 3
            },
            {
              content: '裕华区',

              levelNumber: 3
            },
            {
              content: '藁城区',

              levelNumber: 3
            },
            {
              content: '鹿泉区',

              levelNumber: 3
            },
            {
              content: '栾城区',

              levelNumber: 3
            },
            {
              content: '井陉县',

              levelNumber: 3
            },
            {
              content: '正定县',

              levelNumber: 3
            },
            {
              content: '行唐县',

              levelNumber: 3
            },
            {
              content: '灵寿县',

              levelNumber: 3
            },
            {
              content: '高邑县',

              levelNumber: 3
            },
            {
              content: '深泽县',

              levelNumber: 3
            },
            {
              content: '赞皇县',

              levelNumber: 3
            },
            {
              content: '无极县',

              levelNumber: 3
            },
            {
              content: '平山县',

              levelNumber: 3
            },
            {
              content: '元氏县',

              levelNumber: 3
            },
            {
              content: '赵县',

              levelNumber: 3
            },
            {
              content: '辛集市',

              levelNumber: 3
            },
            {
              content: '晋州市',

              levelNumber: 3
            },
            {
              content: '新乐市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '唐山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '路南区',

              levelNumber: 3
            },
            {
              content: '路北区',

              levelNumber: 3
            },
            {
              content: '古冶区',

              levelNumber: 3
            },
            {
              content: '开平区',

              levelNumber: 3
            },
            {
              content: '丰南区',

              levelNumber: 3
            },
            {
              content: '丰润区',

              levelNumber: 3
            },
            {
              content: '曹妃甸区',

              levelNumber: 3
            },
            {
              content: '滦南县',

              levelNumber: 3
            },
            {
              content: '乐亭县',

              levelNumber: 3
            },
            {
              content: '迁西县',

              levelNumber: 3
            },
            {
              content: '玉田县',

              levelNumber: 3
            },
            {
              content: '遵化市',

              levelNumber: 3
            },
            {
              content: '迁安市',

              levelNumber: 3
            },
            {
              content: '滦州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '秦皇岛市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海港区',

              levelNumber: 3
            },
            {
              content: '山海关区',

              levelNumber: 3
            },
            {
              content: '北戴河区',

              levelNumber: 3
            },
            {
              content: '抚宁区',

              levelNumber: 3
            },
            {
              content: '青龙满族自治县',

              levelNumber: 3
            },
            {
              content: '昌黎县',

              levelNumber: 3
            },
            {
              content: '卢龙县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '邯郸市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '邯山区',

              levelNumber: 3
            },
            {
              content: '丛台区',

              levelNumber: 3
            },
            {
              content: '复兴区',

              levelNumber: 3
            },
            {
              content: '峰峰矿区',

              levelNumber: 3
            },
            {
              content: '肥乡区',

              levelNumber: 3
            },
            {
              content: '永年区',

              levelNumber: 3
            },
            {
              content: '临漳县',

              levelNumber: 3
            },
            {
              content: '成安县',

              levelNumber: 3
            },
            {
              content: '大名县',

              levelNumber: 3
            },
            {
              content: '涉县',

              levelNumber: 3
            },
            {
              content: '磁县',

              levelNumber: 3
            },
            {
              content: '邱县',

              levelNumber: 3
            },
            {
              content: '鸡泽县',

              levelNumber: 3
            },
            {
              content: '广平县',

              levelNumber: 3
            },
            {
              content: '馆陶县',

              levelNumber: 3
            },
            {
              content: '魏县',

              levelNumber: 3
            },
            {
              content: '曲周县',

              levelNumber: 3
            },
            {
              content: '武安市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '邢台市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '襄都区',

              levelNumber: 3
            },
            {
              content: '信都区',

              levelNumber: 3
            },
            {
              content: '任泽区',

              levelNumber: 3
            },
            {
              content: '南和区',

              levelNumber: 3
            },
            {
              content: '临城县',

              levelNumber: 3
            },
            {
              content: '内丘县',

              levelNumber: 3
            },
            {
              content: '柏乡县',

              levelNumber: 3
            },
            {
              content: '隆尧县',

              levelNumber: 3
            },
            {
              content: '宁晋县',

              levelNumber: 3
            },
            {
              content: '巨鹿县',

              levelNumber: 3
            },
            {
              content: '新河县',

              levelNumber: 3
            },
            {
              content: '广宗县',

              levelNumber: 3
            },
            {
              content: '平乡县',

              levelNumber: 3
            },
            {
              content: '威县',

              levelNumber: 3
            },
            {
              content: '清河县',

              levelNumber: 3
            },
            {
              content: '临西县',

              levelNumber: 3
            },
            {
              content: '南宫市',

              levelNumber: 3
            },
            {
              content: '沙河市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '保定市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '竞秀区',

              levelNumber: 3
            },
            {
              content: '莲池区',

              levelNumber: 3
            },
            {
              content: '满城区',

              levelNumber: 3
            },
            {
              content: '清苑区',

              levelNumber: 3
            },
            {
              content: '徐水区',

              levelNumber: 3
            },
            {
              content: '涞水县',

              levelNumber: 3
            },
            {
              content: '阜平县',

              levelNumber: 3
            },
            {
              content: '定兴县',

              levelNumber: 3
            },
            {
              content: '唐县',

              levelNumber: 3
            },
            {
              content: '高阳县',

              levelNumber: 3
            },
            {
              content: '容城县',

              levelNumber: 3
            },
            {
              content: '涞源县',

              levelNumber: 3
            },
            {
              content: '望都县',

              levelNumber: 3
            },
            {
              content: '安新县',

              levelNumber: 3
            },
            {
              content: '易县',

              levelNumber: 3
            },
            {
              content: '曲阳县',

              levelNumber: 3
            },
            {
              content: '蠡县',

              levelNumber: 3
            },
            {
              content: '顺平县',

              levelNumber: 3
            },
            {
              content: '博野县',

              levelNumber: 3
            },
            {
              content: '雄县',

              levelNumber: 3
            },
            {
              content: '涿州市',

              levelNumber: 3
            },
            {
              content: '定州市',

              levelNumber: 3
            },
            {
              content: '安国市',

              levelNumber: 3
            },
            {
              content: '高碑店市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '张家口市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '桥东区',

              levelNumber: 3
            },
            {
              content: '桥西区',

              levelNumber: 3
            },
            {
              content: '宣化区',

              levelNumber: 3
            },
            {
              content: '下花园区',

              levelNumber: 3
            },
            {
              content: '万全区',

              levelNumber: 3
            },
            {
              content: '崇礼区',

              levelNumber: 3
            },
            {
              content: '张北县',

              levelNumber: 3
            },
            {
              content: '康保县',

              levelNumber: 3
            },
            {
              content: '沽源县',

              levelNumber: 3
            },
            {
              content: '尚义县',

              levelNumber: 3
            },
            {
              content: '蔚县',

              levelNumber: 3
            },
            {
              content: '阳原县',

              levelNumber: 3
            },
            {
              content: '怀安县',

              levelNumber: 3
            },
            {
              content: '怀来县',

              levelNumber: 3
            },
            {
              content: '涿鹿县',

              levelNumber: 3
            },
            {
              content: '赤城县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '承德市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '双桥区',

              levelNumber: 3
            },
            {
              content: '双滦区',

              levelNumber: 3
            },
            {
              content: '鹰手营子矿区',

              levelNumber: 3
            },
            {
              content: '承德县',

              levelNumber: 3
            },
            {
              content: '兴隆县',

              levelNumber: 3
            },
            {
              content: '滦平县',

              levelNumber: 3
            },
            {
              content: '隆化县',

              levelNumber: 3
            },
            {
              content: '丰宁满族自治县',

              levelNumber: 3
            },
            {
              content: '宽城满族自治县',

              levelNumber: 3
            },
            {
              content: '围场满族蒙古族自治县',

              levelNumber: 3
            },
            {
              content: '平泉市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '沧州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新华区',

              levelNumber: 3
            },
            {
              content: '运河区',

              levelNumber: 3
            },
            {
              content: '沧县',

              levelNumber: 3
            },
            {
              content: '青县',

              levelNumber: 3
            },
            {
              content: '东光县',

              levelNumber: 3
            },
            {
              content: '海兴县',

              levelNumber: 3
            },
            {
              content: '盐山县',

              levelNumber: 3
            },
            {
              content: '肃宁县',

              levelNumber: 3
            },
            {
              content: '南皮县',

              levelNumber: 3
            },
            {
              content: '吴桥县',

              levelNumber: 3
            },
            {
              content: '献县',

              levelNumber: 3
            },
            {
              content: '孟村回族自治县',

              levelNumber: 3
            },
            {
              content: '泊头市',

              levelNumber: 3
            },
            {
              content: '任丘市',

              levelNumber: 3
            },
            {
              content: '黄骅市',

              levelNumber: 3
            },
            {
              content: '河间市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '廊坊市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '安次区',

              levelNumber: 3
            },
            {
              content: '广阳区',

              levelNumber: 3
            },
            {
              content: '固安县',

              levelNumber: 3
            },
            {
              content: '永清县',

              levelNumber: 3
            },
            {
              content: '香河县',

              levelNumber: 3
            },
            {
              content: '大城县',

              levelNumber: 3
            },
            {
              content: '文安县',

              levelNumber: 3
            },
            {
              content: '大厂回族自治县',

              levelNumber: 3
            },
            {
              content: '霸州市',

              levelNumber: 3
            },
            {
              content: '三河市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '衡水市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '桃城区',

              levelNumber: 3
            },
            {
              content: '冀州区',

              levelNumber: 3
            },
            {
              content: '枣强县',

              levelNumber: 3
            },
            {
              content: '武邑县',

              levelNumber: 3
            },
            {
              content: '武强县',

              levelNumber: 3
            },
            {
              content: '饶阳县',

              levelNumber: 3
            },
            {
              content: '安平县',

              levelNumber: 3
            },
            {
              content: '故城县',

              levelNumber: 3
            },
            {
              content: '景县',

              levelNumber: 3
            },
            {
              content: '阜城县',

              levelNumber: 3
            },
            {
              content: '深州市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '山西省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '太原市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '小店区',

              levelNumber: 3
            },
            {
              content: '迎泽区',

              levelNumber: 3
            },
            {
              content: '杏花岭区',

              levelNumber: 3
            },
            {
              content: '尖草坪区',

              levelNumber: 3
            },
            {
              content: '万柏林区',

              levelNumber: 3
            },
            {
              content: '晋源区',

              levelNumber: 3
            },
            {
              content: '清徐县',

              levelNumber: 3
            },
            {
              content: '阳曲县',

              levelNumber: 3
            },
            {
              content: '娄烦县',

              levelNumber: 3
            },
            {
              content: '古交市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '大同市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新荣区',

              levelNumber: 3
            },
            {
              content: '平城区',

              levelNumber: 3
            },
            {
              content: '云冈区',

              levelNumber: 3
            },
            {
              content: '云州区',

              levelNumber: 3
            },
            {
              content: '阳高县',

              levelNumber: 3
            },
            {
              content: '天镇县',

              levelNumber: 3
            },
            {
              content: '广灵县',

              levelNumber: 3
            },
            {
              content: '灵丘县',

              levelNumber: 3
            },
            {
              content: '浑源县',

              levelNumber: 3
            },
            {
              content: '左云县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阳泉市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城区',

              levelNumber: 3
            },
            {
              content: '矿区',

              levelNumber: 3
            },
            {
              content: '郊区',

              levelNumber: 3
            },
            {
              content: '平定县',

              levelNumber: 3
            },
            { content: '盂县', levelNumber: 3 }
          ]
        },
        {
          content: '长治市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '潞州区',

              levelNumber: 3
            },
            {
              content: '上党区',

              levelNumber: 3
            },
            {
              content: '屯留区',

              levelNumber: 3
            },
            {
              content: '潞城区',

              levelNumber: 3
            },
            {
              content: '襄垣县',

              levelNumber: 3
            },
            {
              content: '平顺县',

              levelNumber: 3
            },
            {
              content: '黎城县',

              levelNumber: 3
            },
            {
              content: '壶关县',

              levelNumber: 3
            },
            {
              content: '长子县',

              levelNumber: 3
            },
            {
              content: '武乡县',

              levelNumber: 3
            },
            {
              content: '沁县',

              levelNumber: 3
            },
            {
              content: '沁源县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '晋城市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城区',

              levelNumber: 3
            },
            {
              content: '沁水县',

              levelNumber: 3
            },
            {
              content: '阳城县',

              levelNumber: 3
            },
            {
              content: '陵川县',

              levelNumber: 3
            },
            {
              content: '泽州县',

              levelNumber: 3
            },
            {
              content: '高平市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '朔州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '朔城区',

              levelNumber: 3
            },
            {
              content: '平鲁区',

              levelNumber: 3
            },
            {
              content: '山阴县',

              levelNumber: 3
            },
            {
              content: '应县',

              levelNumber: 3
            },
            {
              content: '右玉县',

              levelNumber: 3
            },
            {
              content: '怀仁市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '晋中市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '榆次区',

              levelNumber: 3
            },
            {
              content: '太谷区',

              levelNumber: 3
            },
            {
              content: '榆社县',

              levelNumber: 3
            },
            {
              content: '左权县',

              levelNumber: 3
            },
            {
              content: '和顺县',

              levelNumber: 3
            },
            {
              content: '昔阳县',

              levelNumber: 3
            },
            {
              content: '寿阳县',

              levelNumber: 3
            },
            {
              content: '祁县',

              levelNumber: 3
            },
            {
              content: '平遥县',

              levelNumber: 3
            },
            {
              content: '灵石县',

              levelNumber: 3
            },
            {
              content: '介休市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '运城市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '盐湖区',

              levelNumber: 3
            },
            {
              content: '临猗县',

              levelNumber: 3
            },
            {
              content: '万荣县',

              levelNumber: 3
            },
            {
              content: '闻喜县',

              levelNumber: 3
            },
            {
              content: '稷山县',

              levelNumber: 3
            },
            {
              content: '新绛县',

              levelNumber: 3
            },
            {
              content: '绛县',

              levelNumber: 3
            },
            {
              content: '垣曲县',

              levelNumber: 3
            },
            {
              content: '夏县',

              levelNumber: 3
            },
            {
              content: '平陆县',

              levelNumber: 3
            },
            {
              content: '芮城县',

              levelNumber: 3
            },
            {
              content: '永济市',

              levelNumber: 3
            },
            {
              content: '河津市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '忻州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '忻府区',

              levelNumber: 3
            },
            {
              content: '定襄县',

              levelNumber: 3
            },
            {
              content: '五台县',

              levelNumber: 3
            },
            {
              content: '代县',

              levelNumber: 3
            },
            {
              content: '繁峙县',

              levelNumber: 3
            },
            {
              content: '宁武县',

              levelNumber: 3
            },
            {
              content: '静乐县',

              levelNumber: 3
            },
            {
              content: '神池县',

              levelNumber: 3
            },
            {
              content: '五寨县',

              levelNumber: 3
            },
            {
              content: '岢岚县',

              levelNumber: 3
            },
            {
              content: '河曲县',

              levelNumber: 3
            },
            {
              content: '保德县',

              levelNumber: 3
            },
            {
              content: '偏关县',

              levelNumber: 3
            },
            {
              content: '原平市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '临汾市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '尧都区',

              levelNumber: 3
            },
            {
              content: '曲沃县',

              levelNumber: 3
            },
            {
              content: '翼城县',

              levelNumber: 3
            },
            {
              content: '襄汾县',

              levelNumber: 3
            },
            {
              content: '洪洞县',

              levelNumber: 3
            },
            {
              content: '古县',

              levelNumber: 3
            },
            {
              content: '安泽县',

              levelNumber: 3
            },
            {
              content: '浮山县',

              levelNumber: 3
            },
            {
              content: '吉县',

              levelNumber: 3
            },
            {
              content: '乡宁县',

              levelNumber: 3
            },
            {
              content: '大宁县',

              levelNumber: 3
            },
            {
              content: '隰县',

              levelNumber: 3
            },
            {
              content: '永和县',

              levelNumber: 3
            },
            {
              content: '蒲县',

              levelNumber: 3
            },
            {
              content: '汾西县',

              levelNumber: 3
            },
            {
              content: '侯马市',

              levelNumber: 3
            },
            {
              content: '霍州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '吕梁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '离石区',

              levelNumber: 3
            },
            {
              content: '文水县',

              levelNumber: 3
            },
            {
              content: '交城县',

              levelNumber: 3
            },
            {
              content: '兴县',

              levelNumber: 3
            },
            {
              content: '临县',

              levelNumber: 3
            },
            {
              content: '柳林县',

              levelNumber: 3
            },
            {
              content: '石楼县',

              levelNumber: 3
            },
            {
              content: '岚县',

              levelNumber: 3
            },
            {
              content: '方山县',

              levelNumber: 3
            },
            {
              content: '中阳县',

              levelNumber: 3
            },
            {
              content: '交口县',

              levelNumber: 3
            },
            {
              content: '孝义市',

              levelNumber: 3
            },
            {
              content: '汾阳市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '内蒙古自治区',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '呼和浩特市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新城区',

              levelNumber: 3
            },
            {
              content: '回民区',

              levelNumber: 3
            },
            {
              content: '玉泉区',

              levelNumber: 3
            },
            {
              content: '赛罕区',

              levelNumber: 3
            },
            {
              content: '土默特左旗',

              levelNumber: 3
            },
            {
              content: '托克托县',

              levelNumber: 3
            },
            {
              content: '和林格尔县',

              levelNumber: 3
            },
            {
              content: '清水河县',

              levelNumber: 3
            },
            {
              content: '武川县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '包头市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东河区',

              levelNumber: 3
            },
            {
              content: '昆都仑区',

              levelNumber: 3
            },
            {
              content: '青山区',

              levelNumber: 3
            },
            {
              content: '石拐区',

              levelNumber: 3
            },
            {
              content: '白云鄂博矿区',

              levelNumber: 3
            },
            {
              content: '九原区',

              levelNumber: 3
            },
            {
              content: '土默特右旗',

              levelNumber: 3
            },
            {
              content: '固阳县',

              levelNumber: 3
            },
            {
              content: '达尔罕茂明安联合旗',

              levelNumber: 3
            }
          ]
        },
        {
          content: '乌海市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海勃湾区',

              levelNumber: 3
            },
            {
              content: '海南区',

              levelNumber: 3
            },
            {
              content: '乌达区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '赤峰市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '红山区',

              levelNumber: 3
            },
            {
              content: '元宝山区',

              levelNumber: 3
            },
            {
              content: '松山区',

              levelNumber: 3
            },
            {
              content: '阿鲁科尔沁旗',

              levelNumber: 3
            },
            {
              content: '巴林左旗',

              levelNumber: 3
            },
            {
              content: '巴林右旗',

              levelNumber: 3
            },
            {
              content: '林西县',

              levelNumber: 3
            },
            {
              content: '克什克腾旗',

              levelNumber: 3
            },
            {
              content: '翁牛特旗',

              levelNumber: 3
            },
            {
              content: '喀喇沁旗',

              levelNumber: 3
            },
            {
              content: '宁城县',

              levelNumber: 3
            },
            {
              content: '敖汉旗',

              levelNumber: 3
            }
          ]
        },
        {
          content: '通辽市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '科尔沁区',

              levelNumber: 3
            },
            {
              content: '科尔沁左翼中旗',

              levelNumber: 3
            },
            {
              content: '科尔沁左翼后旗',

              levelNumber: 3
            },
            {
              content: '开鲁县',

              levelNumber: 3
            },
            {
              content: '库伦旗',

              levelNumber: 3
            },
            {
              content: '奈曼旗',

              levelNumber: 3
            },
            {
              content: '扎鲁特旗',

              levelNumber: 3
            },
            {
              content: '霍林郭勒市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '鄂尔多斯市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东胜区',

              levelNumber: 3
            },
            {
              content: '康巴什区',

              levelNumber: 3
            },
            {
              content: '达拉特旗',

              levelNumber: 3
            },
            {
              content: '准格尔旗',

              levelNumber: 3
            },
            {
              content: '鄂托克前旗',

              levelNumber: 3
            },
            {
              content: '鄂托克旗',

              levelNumber: 3
            },
            {
              content: '杭锦旗',

              levelNumber: 3
            },
            {
              content: '乌审旗',

              levelNumber: 3
            },
            {
              content: '伊金霍洛旗',

              levelNumber: 3
            }
          ]
        },
        {
          content: '呼伦贝尔市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海拉尔区',

              levelNumber: 3
            },
            {
              content: '扎赉诺尔区',

              levelNumber: 3
            },
            {
              content: '阿荣旗',

              levelNumber: 3
            },
            {
              content: '莫力达瓦达斡尔族自治旗',

              levelNumber: 3
            },
            {
              content: '鄂伦春自治旗',

              levelNumber: 3
            },
            {
              content: '鄂温克族自治旗',

              levelNumber: 3
            },
            {
              content: '陈巴尔虎旗',

              levelNumber: 3
            },
            {
              content: '新巴尔虎左旗',

              levelNumber: 3
            },
            {
              content: '新巴尔虎右旗',

              levelNumber: 3
            },
            {
              content: '满洲里市',

              levelNumber: 3
            },
            {
              content: '牙克石市',

              levelNumber: 3
            },
            {
              content: '扎兰屯市',

              levelNumber: 3
            },
            {
              content: '额尔古纳市',

              levelNumber: 3
            },
            {
              content: '根河市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '巴彦淖尔市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '临河区',

              levelNumber: 3
            },
            {
              content: '五原县',

              levelNumber: 3
            },
            {
              content: '磴口县',

              levelNumber: 3
            },
            {
              content: '乌拉特前旗',

              levelNumber: 3
            },
            {
              content: '乌拉特中旗',

              levelNumber: 3
            },
            {
              content: '乌拉特后旗',

              levelNumber: 3
            },
            {
              content: '杭锦后旗',

              levelNumber: 3
            }
          ]
        },
        {
          content: '乌兰察布市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '集宁区',

              levelNumber: 3
            },
            {
              content: '卓资县',

              levelNumber: 3
            },
            {
              content: '化德县',

              levelNumber: 3
            },
            {
              content: '商都县',

              levelNumber: 3
            },
            {
              content: '兴和县',

              levelNumber: 3
            },
            {
              content: '凉城县',

              levelNumber: 3
            },
            {
              content: '察哈尔右翼前旗',

              levelNumber: 3
            },
            {
              content: '察哈尔右翼中旗',

              levelNumber: 3
            },
            {
              content: '察哈尔右翼后旗',

              levelNumber: 3
            },
            {
              content: '四子王旗',

              levelNumber: 3
            },
            {
              content: '丰镇市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '兴安盟',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '乌兰浩特市',

              levelNumber: 3
            },
            {
              content: '阿尔山市',

              levelNumber: 3
            },
            {
              content: '科尔沁右翼前旗',

              levelNumber: 3
            },
            {
              content: '科尔沁右翼中旗',

              levelNumber: 3
            },
            {
              content: '扎赉特旗',

              levelNumber: 3
            },
            {
              content: '突泉县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '锡林郭勒盟',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '二连浩特市',

              levelNumber: 3
            },
            {
              content: '锡林浩特市',

              levelNumber: 3
            },
            {
              content: '阿巴嘎旗',

              levelNumber: 3
            },
            {
              content: '苏尼特左旗',

              levelNumber: 3
            },
            {
              content: '苏尼特右旗',

              levelNumber: 3
            },
            {
              content: '东乌珠穆沁旗',

              levelNumber: 3
            },
            {
              content: '西乌珠穆沁旗',

              levelNumber: 3
            },
            {
              content: '太仆寺旗',

              levelNumber: 3
            },
            {
              content: '镶黄旗',

              levelNumber: 3
            },
            {
              content: '正镶白旗',

              levelNumber: 3
            },
            {
              content: '正蓝旗',

              levelNumber: 3
            },
            {
              content: '多伦县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阿拉善盟',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '阿拉善左旗',

              levelNumber: 3
            },
            {
              content: '阿拉善右旗',

              levelNumber: 3
            },
            {
              content: '额济纳旗',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '辽宁省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '沈阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '和平区',

              levelNumber: 3
            },
            {
              content: '沈河区',

              levelNumber: 3
            },
            {
              content: '大东区',

              levelNumber: 3
            },
            {
              content: '皇姑区',

              levelNumber: 3
            },
            {
              content: '铁西区',

              levelNumber: 3
            },
            {
              content: '苏家屯区',

              levelNumber: 3
            },
            {
              content: '浑南区',

              levelNumber: 3
            },
            {
              content: '沈北新区',

              levelNumber: 3
            },
            {
              content: '于洪区',

              levelNumber: 3
            },
            {
              content: '辽中区',

              levelNumber: 3
            },
            {
              content: '康平县',

              levelNumber: 3
            },
            {
              content: '法库县',

              levelNumber: 3
            },
            {
              content: '新民市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '大连市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '中山区',

              levelNumber: 3
            },
            {
              content: '西岗区',

              levelNumber: 3
            },
            {
              content: '沙河口区',

              levelNumber: 3
            },
            {
              content: '甘井子区',

              levelNumber: 3
            },
            {
              content: '旅顺口区',

              levelNumber: 3
            },
            {
              content: '金州区',

              levelNumber: 3
            },
            {
              content: '普兰店区',

              levelNumber: 3
            },
            {
              content: '长海县',

              levelNumber: 3
            },
            {
              content: '瓦房店市',

              levelNumber: 3
            },
            {
              content: '庄河市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '鞍山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '铁东区',

              levelNumber: 3
            },
            {
              content: '铁西区',

              levelNumber: 3
            },
            {
              content: '立山区',

              levelNumber: 3
            },
            {
              content: '千山区',

              levelNumber: 3
            },
            {
              content: '台安县',

              levelNumber: 3
            },
            {
              content: '岫岩满族自治县',

              levelNumber: 3
            },
            {
              content: '海城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '抚顺市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新抚区',

              levelNumber: 3
            },
            {
              content: '东洲区',

              levelNumber: 3
            },
            {
              content: '望花区',

              levelNumber: 3
            },
            {
              content: '顺城区',

              levelNumber: 3
            },
            {
              content: '抚顺县',

              levelNumber: 3
            },
            {
              content: '新宾满族自治县',

              levelNumber: 3
            },
            {
              content: '清原满族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '本溪市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '平山区',

              levelNumber: 3
            },
            {
              content: '溪湖区',

              levelNumber: 3
            },
            {
              content: '明山区',

              levelNumber: 3
            },
            {
              content: '南芬区',

              levelNumber: 3
            },
            {
              content: '本溪满族自治县',

              levelNumber: 3
            },
            {
              content: '桓仁满族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '丹东市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '元宝区',

              levelNumber: 3
            },
            {
              content: '振兴区',

              levelNumber: 3
            },
            {
              content: '振安区',

              levelNumber: 3
            },
            {
              content: '宽甸满族自治县',

              levelNumber: 3
            },
            {
              content: '东港市',

              levelNumber: 3
            },
            {
              content: '凤城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '锦州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '古塔区',

              levelNumber: 3
            },
            {
              content: '凌河区',

              levelNumber: 3
            },
            {
              content: '太和区',

              levelNumber: 3
            },
            {
              content: '黑山县',

              levelNumber: 3
            },
            {
              content: '义县',

              levelNumber: 3
            },
            {
              content: '凌海市',

              levelNumber: 3
            },
            {
              content: '北镇市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '营口市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '站前区',

              levelNumber: 3
            },
            {
              content: '西市区',

              levelNumber: 3
            },
            {
              content: '鲅鱼圈区',

              levelNumber: 3
            },
            {
              content: '老边区',

              levelNumber: 3
            },
            {
              content: '盖州市',

              levelNumber: 3
            },
            {
              content: '大石桥市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阜新市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海州区',

              levelNumber: 3
            },
            {
              content: '新邱区',

              levelNumber: 3
            },
            {
              content: '太平区',

              levelNumber: 3
            },
            {
              content: '清河门区',

              levelNumber: 3
            },
            {
              content: '细河区',

              levelNumber: 3
            },
            {
              content: '阜新蒙古族自治县',

              levelNumber: 3
            },
            {
              content: '彰武县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '辽阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '白塔区',

              levelNumber: 3
            },
            {
              content: '文圣区',

              levelNumber: 3
            },
            {
              content: '宏伟区',

              levelNumber: 3
            },
            {
              content: '弓长岭区',

              levelNumber: 3
            },
            {
              content: '太子河区',

              levelNumber: 3
            },
            {
              content: '辽阳县',

              levelNumber: 3
            },
            {
              content: '灯塔市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '盘锦市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '双台子区',

              levelNumber: 3
            },
            {
              content: '兴隆台区',

              levelNumber: 3
            },
            {
              content: '大洼区',

              levelNumber: 3
            },
            {
              content: '盘山县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '铁岭市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '银州区',

              levelNumber: 3
            },
            {
              content: '清河区',

              levelNumber: 3
            },
            {
              content: '铁岭县',

              levelNumber: 3
            },
            {
              content: '西丰县',

              levelNumber: 3
            },
            {
              content: '昌图县',

              levelNumber: 3
            },
            {
              content: '调兵山市',

              levelNumber: 3
            },
            {
              content: '开原市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '朝阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '双塔区',

              levelNumber: 3
            },
            {
              content: '龙城区',

              levelNumber: 3
            },
            {
              content: '朝阳县',

              levelNumber: 3
            },
            {
              content: '建平县',

              levelNumber: 3
            },
            {
              content: '喀喇沁左翼蒙古族自治县',

              levelNumber: 3
            },
            {
              content: '北票市',

              levelNumber: 3
            },
            {
              content: '凌源市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '葫芦岛市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '连山区',

              levelNumber: 3
            },
            {
              content: '龙港区',

              levelNumber: 3
            },
            {
              content: '南票区',

              levelNumber: 3
            },
            {
              content: '绥中县',

              levelNumber: 3
            },
            {
              content: '建昌县',

              levelNumber: 3
            },
            {
              content: '兴城市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '吉林省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '长春市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '南关区',

              levelNumber: 3
            },
            {
              content: '宽城区',

              levelNumber: 3
            },
            {
              content: '朝阳区',

              levelNumber: 3
            },
            {
              content: '二道区',

              levelNumber: 3
            },
            {
              content: '绿园区',

              levelNumber: 3
            },
            {
              content: '双阳区',

              levelNumber: 3
            },
            {
              content: '九台区',

              levelNumber: 3
            },
            {
              content: '农安县',

              levelNumber: 3
            },
            {
              content: '榆树市',

              levelNumber: 3
            },
            {
              content: '德惠市',

              levelNumber: 3
            },
            {
              content: '公主岭市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '吉林市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '昌邑区',

              levelNumber: 3
            },
            {
              content: '龙潭区',

              levelNumber: 3
            },
            {
              content: '船营区',

              levelNumber: 3
            },
            {
              content: '丰满区',

              levelNumber: 3
            },
            {
              content: '永吉县',

              levelNumber: 3
            },
            {
              content: '蛟河市',

              levelNumber: 3
            },
            {
              content: '桦甸市',

              levelNumber: 3
            },
            {
              content: '舒兰市',

              levelNumber: 3
            },
            {
              content: '磐石市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '四平市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '铁西区',

              levelNumber: 3
            },
            {
              content: '铁东区',

              levelNumber: 3
            },
            {
              content: '梨树县',

              levelNumber: 3
            },
            {
              content: '伊通满族自治县',

              levelNumber: 3
            },
            {
              content: '双辽市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '辽源市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '龙山区',

              levelNumber: 3
            },
            {
              content: '西安区',

              levelNumber: 3
            },
            {
              content: '东丰县',

              levelNumber: 3
            },
            {
              content: '东辽县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '通化市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东昌区',

              levelNumber: 3
            },
            {
              content: '二道江区',

              levelNumber: 3
            },
            {
              content: '通化县',

              levelNumber: 3
            },
            {
              content: '辉南县',

              levelNumber: 3
            },
            {
              content: '柳河县',

              levelNumber: 3
            },
            {
              content: '梅河口市',

              levelNumber: 3
            },
            {
              content: '集安市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '白山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '浑江区',

              levelNumber: 3
            },
            {
              content: '江源区',

              levelNumber: 3
            },
            {
              content: '抚松县',

              levelNumber: 3
            },
            {
              content: '靖宇县',

              levelNumber: 3
            },
            {
              content: '长白朝鲜族自治县',

              levelNumber: 3
            },
            {
              content: '临江市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '松原市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '宁江区',

              levelNumber: 3
            },
            {
              content: '前郭尔罗斯蒙古族自治县',

              levelNumber: 3
            },
            {
              content: '长岭县',

              levelNumber: 3
            },
            {
              content: '乾安县',

              levelNumber: 3
            },
            {
              content: '扶余市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '白城市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '洮北区',

              levelNumber: 3
            },
            {
              content: '镇赉县',

              levelNumber: 3
            },
            {
              content: '通榆县',

              levelNumber: 3
            },
            {
              content: '洮南市',

              levelNumber: 3
            },
            {
              content: '大安市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '延边朝鲜族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '延吉市',

              levelNumber: 3
            },
            {
              content: '图们市',

              levelNumber: 3
            },
            {
              content: '敦化市',

              levelNumber: 3
            },
            {
              content: '珲春市',

              levelNumber: 3
            },
            {
              content: '龙井市',

              levelNumber: 3
            },
            {
              content: '和龙市',

              levelNumber: 3
            },
            {
              content: '汪清县',

              levelNumber: 3
            },
            {
              content: '安图县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '黑龙江省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '哈尔滨市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '道里区',

              levelNumber: 3
            },
            {
              content: '南岗区',

              levelNumber: 3
            },
            {
              content: '道外区',

              levelNumber: 3
            },
            {
              content: '平房区',

              levelNumber: 3
            },
            {
              content: '松北区',

              levelNumber: 3
            },
            {
              content: '香坊区',

              levelNumber: 3
            },
            {
              content: '呼兰区',

              levelNumber: 3
            },
            {
              content: '阿城区',

              levelNumber: 3
            },
            {
              content: '双城区',

              levelNumber: 3
            },
            {
              content: '依兰县',

              levelNumber: 3
            },
            {
              content: '方正县',

              levelNumber: 3
            },
            {
              content: '宾县',

              levelNumber: 3
            },
            {
              content: '巴彦县',

              levelNumber: 3
            },
            {
              content: '木兰县',

              levelNumber: 3
            },
            {
              content: '通河县',

              levelNumber: 3
            },
            {
              content: '延寿县',

              levelNumber: 3
            },
            {
              content: '尚志市',

              levelNumber: 3
            },
            {
              content: '五常市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '齐齐哈尔市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '龙沙区',

              levelNumber: 3
            },
            {
              content: '建华区',

              levelNumber: 3
            },
            {
              content: '铁锋区',

              levelNumber: 3
            },
            {
              content: '昂昂溪区',

              levelNumber: 3
            },
            {
              content: '富拉尔基区',

              levelNumber: 3
            },
            {
              content: '碾子山区',

              levelNumber: 3
            },
            {
              content: '梅里斯达斡尔族区',

              levelNumber: 3
            },
            {
              content: '龙江县',

              levelNumber: 3
            },
            {
              content: '依安县',

              levelNumber: 3
            },
            {
              content: '泰来县',

              levelNumber: 3
            },
            {
              content: '甘南县',

              levelNumber: 3
            },
            {
              content: '富裕县',

              levelNumber: 3
            },
            {
              content: '克山县',

              levelNumber: 3
            },
            {
              content: '克东县',

              levelNumber: 3
            },
            {
              content: '拜泉县',

              levelNumber: 3
            },
            {
              content: '讷河市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '鸡西市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '鸡冠区',

              levelNumber: 3
            },
            {
              content: '恒山区',

              levelNumber: 3
            },
            {
              content: '滴道区',

              levelNumber: 3
            },
            {
              content: '梨树区',

              levelNumber: 3
            },
            {
              content: '城子河区',

              levelNumber: 3
            },
            {
              content: '麻山区',

              levelNumber: 3
            },
            {
              content: '鸡东县',

              levelNumber: 3
            },
            {
              content: '虎林市',

              levelNumber: 3
            },
            {
              content: '密山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '鹤岗市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '向阳区',

              levelNumber: 3
            },
            {
              content: '工农区',

              levelNumber: 3
            },
            {
              content: '南山区',

              levelNumber: 3
            },
            {
              content: '兴安区',

              levelNumber: 3
            },
            {
              content: '东山区',

              levelNumber: 3
            },
            {
              content: '兴山区',

              levelNumber: 3
            },
            {
              content: '萝北县',

              levelNumber: 3
            },
            {
              content: '绥滨县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '双鸭山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '尖山区',

              levelNumber: 3
            },
            {
              content: '岭东区',

              levelNumber: 3
            },
            {
              content: '四方台区',

              levelNumber: 3
            },
            {
              content: '宝山区',

              levelNumber: 3
            },
            {
              content: '集贤县',

              levelNumber: 3
            },
            {
              content: '友谊县',

              levelNumber: 3
            },
            {
              content: '宝清县',

              levelNumber: 3
            },
            {
              content: '饶河县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '大庆市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '萨尔图区',

              levelNumber: 3
            },
            {
              content: '龙凤区',

              levelNumber: 3
            },
            {
              content: '让胡路区',

              levelNumber: 3
            },
            {
              content: '红岗区',

              levelNumber: 3
            },
            {
              content: '大同区',

              levelNumber: 3
            },
            {
              content: '肇州县',

              levelNumber: 3
            },
            {
              content: '肇源县',

              levelNumber: 3
            },
            {
              content: '林甸县',

              levelNumber: 3
            },
            {
              content: '杜尔伯特蒙古族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '伊春市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '伊美区',

              levelNumber: 3
            },
            {
              content: '乌翠区',

              levelNumber: 3
            },
            {
              content: '友好区',

              levelNumber: 3
            },
            {
              content: '嘉荫县',

              levelNumber: 3
            },
            {
              content: '汤旺县',

              levelNumber: 3
            },
            {
              content: '丰林县',

              levelNumber: 3
            },
            {
              content: '大箐山县',

              levelNumber: 3
            },
            {
              content: '南岔县',

              levelNumber: 3
            },
            {
              content: '金林区',

              levelNumber: 3
            },
            {
              content: '铁力市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '佳木斯市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '向阳区',

              levelNumber: 3
            },
            {
              content: '前进区',

              levelNumber: 3
            },
            {
              content: '东风区',

              levelNumber: 3
            },
            {
              content: '郊区',

              levelNumber: 3
            },
            {
              content: '桦南县',

              levelNumber: 3
            },
            {
              content: '桦川县',

              levelNumber: 3
            },
            {
              content: '汤原县',

              levelNumber: 3
            },
            {
              content: '同江市',

              levelNumber: 3
            },
            {
              content: '富锦市',

              levelNumber: 3
            },
            {
              content: '抚远市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '七台河市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新兴区',

              levelNumber: 3
            },
            {
              content: '桃山区',

              levelNumber: 3
            },
            {
              content: '茄子河区',

              levelNumber: 3
            },
            {
              content: '勃利县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '牡丹江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东安区',

              levelNumber: 3
            },
            {
              content: '阳明区',

              levelNumber: 3
            },
            {
              content: '爱民区',

              levelNumber: 3
            },
            {
              content: '西安区',

              levelNumber: 3
            },
            {
              content: '林口县',

              levelNumber: 3
            },
            {
              content: '绥芬河市',

              levelNumber: 3
            },
            {
              content: '海林市',

              levelNumber: 3
            },
            {
              content: '宁安市',

              levelNumber: 3
            },
            {
              content: '穆棱市',

              levelNumber: 3
            },
            {
              content: '东宁市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黑河市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '爱辉区',

              levelNumber: 3
            },
            {
              content: '逊克县',

              levelNumber: 3
            },
            {
              content: '孙吴县',

              levelNumber: 3
            },
            {
              content: '北安市',

              levelNumber: 3
            },
            {
              content: '五大连池市',

              levelNumber: 3
            },
            {
              content: '嫩江市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '绥化市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '北林区',

              levelNumber: 3
            },
            {
              content: '望奎县',

              levelNumber: 3
            },
            {
              content: '兰西县',

              levelNumber: 3
            },
            {
              content: '青冈县',

              levelNumber: 3
            },
            {
              content: '庆安县',

              levelNumber: 3
            },
            {
              content: '明水县',

              levelNumber: 3
            },
            {
              content: '绥棱县',

              levelNumber: 3
            },
            {
              content: '安达市',

              levelNumber: 3
            },
            {
              content: '肇东市',

              levelNumber: 3
            },
            {
              content: '海伦市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '大兴安岭地区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '漠河市',

              levelNumber: 3
            },
            {
              content: '加格达奇区',

              levelNumber: 3
            },
            {
              content: '呼玛县',

              levelNumber: 3
            },
            {
              content: '塔河县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '上海市',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '上海城区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '黄浦区',

              levelNumber: 3
            },
            {
              content: '徐汇区',

              levelNumber: 3
            },
            {
              content: '长宁区',

              levelNumber: 3
            },
            {
              content: '静安区',

              levelNumber: 3
            },
            {
              content: '普陀区',

              levelNumber: 3
            },
            {
              content: '虹口区',

              levelNumber: 3
            },
            {
              content: '杨浦区',

              levelNumber: 3
            },
            {
              content: '闵行区',

              levelNumber: 3
            },
            {
              content: '宝山区',

              levelNumber: 3
            },
            {
              content: '嘉定区',

              levelNumber: 3
            },
            {
              content: '浦东新区',

              levelNumber: 3
            },
            {
              content: '金山区',

              levelNumber: 3
            },
            {
              content: '松江区',

              levelNumber: 3
            },
            {
              content: '青浦区',

              levelNumber: 3
            },
            {
              content: '奉贤区',

              levelNumber: 3
            },
            {
              content: '崇明区',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '江苏省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '南京市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '玄武区',

              levelNumber: 3
            },
            {
              content: '秦淮区',

              levelNumber: 3
            },
            {
              content: '建邺区',

              levelNumber: 3
            },
            {
              content: '鼓楼区',

              levelNumber: 3
            },
            {
              content: '浦口区',

              levelNumber: 3
            },
            {
              content: '栖霞区',

              levelNumber: 3
            },
            {
              content: '雨花台区',

              levelNumber: 3
            },
            {
              content: '江宁区',

              levelNumber: 3
            },
            {
              content: '六合区',

              levelNumber: 3
            },
            {
              content: '溧水区',

              levelNumber: 3
            },
            {
              content: '高淳区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '无锡市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '锡山区',

              levelNumber: 3
            },
            {
              content: '惠山区',

              levelNumber: 3
            },
            {
              content: '滨湖区',

              levelNumber: 3
            },
            {
              content: '梁溪区',

              levelNumber: 3
            },
            {
              content: '新吴区',

              levelNumber: 3
            },
            {
              content: '江阴市',

              levelNumber: 3
            },
            {
              content: '宜兴市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '徐州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '鼓楼区',

              levelNumber: 3
            },
            {
              content: '云龙区',

              levelNumber: 3
            },
            {
              content: '贾汪区',

              levelNumber: 3
            },
            {
              content: '泉山区',

              levelNumber: 3
            },
            {
              content: '铜山区',

              levelNumber: 3
            },
            {
              content: '丰县',

              levelNumber: 3
            },
            {
              content: '沛县',

              levelNumber: 3
            },
            {
              content: '睢宁县',

              levelNumber: 3
            },
            {
              content: '新沂市',

              levelNumber: 3
            },
            {
              content: '邳州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '常州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '天宁区',

              levelNumber: 3
            },
            {
              content: '钟楼区',

              levelNumber: 3
            },
            {
              content: '新北区',

              levelNumber: 3
            },
            {
              content: '武进区',

              levelNumber: 3
            },
            {
              content: '金坛区',

              levelNumber: 3
            },
            {
              content: '溧阳市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '苏州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '虎丘区',

              levelNumber: 3
            },
            {
              content: '吴中区',

              levelNumber: 3
            },
            {
              content: '相城区',

              levelNumber: 3
            },
            {
              content: '姑苏区',

              levelNumber: 3
            },
            {
              content: '吴江区',

              levelNumber: 3
            },
            {
              content: '常熟市',

              levelNumber: 3
            },
            {
              content: '张家港市',

              levelNumber: 3
            },
            {
              content: '昆山市',

              levelNumber: 3
            },
            {
              content: '太仓市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '南通市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '通州区',

              levelNumber: 3
            },
            {
              content: '崇川区',

              levelNumber: 3
            },
            {
              content: '海门区',

              levelNumber: 3
            },
            {
              content: '如东县',

              levelNumber: 3
            },
            {
              content: '启东市',

              levelNumber: 3
            },
            {
              content: '如皋市',

              levelNumber: 3
            },
            {
              content: '海安市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '连云港市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '连云区',

              levelNumber: 3
            },
            {
              content: '海州区',

              levelNumber: 3
            },
            {
              content: '赣榆区',

              levelNumber: 3
            },
            {
              content: '东海县',

              levelNumber: 3
            },
            {
              content: '灌云县',

              levelNumber: 3
            },
            {
              content: '灌南县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '淮安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '淮安区',

              levelNumber: 3
            },
            {
              content: '淮阴区',

              levelNumber: 3
            },
            {
              content: '清江浦区',

              levelNumber: 3
            },
            {
              content: '洪泽区',

              levelNumber: 3
            },
            {
              content: '涟水县',

              levelNumber: 3
            },
            {
              content: '盱眙县',

              levelNumber: 3
            },
            {
              content: '金湖县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '盐城市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '亭湖区',

              levelNumber: 3
            },
            {
              content: '盐都区',

              levelNumber: 3
            },
            {
              content: '大丰区',

              levelNumber: 3
            },
            {
              content: '响水县',

              levelNumber: 3
            },
            {
              content: '滨海县',

              levelNumber: 3
            },
            {
              content: '阜宁县',

              levelNumber: 3
            },
            {
              content: '射阳县',

              levelNumber: 3
            },
            {
              content: '建湖县',

              levelNumber: 3
            },
            {
              content: '东台市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '扬州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '广陵区',

              levelNumber: 3
            },
            {
              content: '邗江区',

              levelNumber: 3
            },
            {
              content: '江都区',

              levelNumber: 3
            },
            {
              content: '宝应县',

              levelNumber: 3
            },
            {
              content: '仪征市',

              levelNumber: 3
            },
            {
              content: '高邮市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '镇江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '京口区',

              levelNumber: 3
            },
            {
              content: '润州区',

              levelNumber: 3
            },
            {
              content: '丹徒区',

              levelNumber: 3
            },
            {
              content: '丹阳市',

              levelNumber: 3
            },
            {
              content: '扬中市',

              levelNumber: 3
            },
            {
              content: '句容市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '泰州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海陵区',

              levelNumber: 3
            },
            {
              content: '高港区',

              levelNumber: 3
            },
            {
              content: '姜堰区',

              levelNumber: 3
            },
            {
              content: '兴化市',

              levelNumber: 3
            },
            {
              content: '靖江市',

              levelNumber: 3
            },
            {
              content: '泰兴市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宿迁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '宿城区',

              levelNumber: 3
            },
            {
              content: '宿豫区',

              levelNumber: 3
            },
            {
              content: '沭阳县',

              levelNumber: 3
            },
            {
              content: '泗阳县',

              levelNumber: 3
            },
            {
              content: '泗洪县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '浙江省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '杭州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '上城区',

              levelNumber: 3
            },
            {
              content: '拱墅区',

              levelNumber: 3
            },
            {
              content: '西湖区',

              levelNumber: 3
            },
            {
              content: '滨江区',

              levelNumber: 3
            },
            {
              content: '萧山区',

              levelNumber: 3
            },
            {
              content: '余杭区',

              levelNumber: 3
            },
            {
              content: '富阳区',

              levelNumber: 3
            },
            {
              content: '临安区',

              levelNumber: 3
            },
            {
              content: '临平区',

              levelNumber: 3
            },
            {
              content: '钱塘区',

              levelNumber: 3
            },
            {
              content: '桐庐县',

              levelNumber: 3
            },
            {
              content: '淳安县',

              levelNumber: 3
            },
            {
              content: '建德市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宁波市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海曙区',

              levelNumber: 3
            },
            {
              content: '江北区',

              levelNumber: 3
            },
            {
              content: '北仑区',

              levelNumber: 3
            },
            {
              content: '镇海区',

              levelNumber: 3
            },
            {
              content: '鄞州区',

              levelNumber: 3
            },
            {
              content: '奉化区',

              levelNumber: 3
            },
            {
              content: '象山县',

              levelNumber: 3
            },
            {
              content: '宁海县',

              levelNumber: 3
            },
            {
              content: '余姚市',

              levelNumber: 3
            },
            {
              content: '慈溪市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '温州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '鹿城区',

              levelNumber: 3
            },
            {
              content: '龙湾区',

              levelNumber: 3
            },
            {
              content: '瓯海区',

              levelNumber: 3
            },
            {
              content: '洞头区',

              levelNumber: 3
            },
            {
              content: '永嘉县',

              levelNumber: 3
            },
            {
              content: '平阳县',

              levelNumber: 3
            },
            {
              content: '苍南县',

              levelNumber: 3
            },
            {
              content: '文成县',

              levelNumber: 3
            },
            {
              content: '泰顺县',

              levelNumber: 3
            },
            {
              content: '瑞安市',

              levelNumber: 3
            },
            {
              content: '乐清市',

              levelNumber: 3
            },
            {
              content: '龙港市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '嘉兴市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '南湖区',

              levelNumber: 3
            },
            {
              content: '秀洲区',

              levelNumber: 3
            },
            {
              content: '嘉善县',

              levelNumber: 3
            },
            {
              content: '海盐县',

              levelNumber: 3
            },
            {
              content: '海宁市',

              levelNumber: 3
            },
            {
              content: '平湖市',

              levelNumber: 3
            },
            {
              content: '桐乡市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '湖州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '吴兴区',

              levelNumber: 3
            },
            {
              content: '南浔区',

              levelNumber: 3
            },
            {
              content: '德清县',

              levelNumber: 3
            },
            {
              content: '长兴县',

              levelNumber: 3
            },
            {
              content: '安吉县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '绍兴市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '越城区',

              levelNumber: 3
            },
            {
              content: '柯桥区',

              levelNumber: 3
            },
            {
              content: '上虞区',

              levelNumber: 3
            },
            {
              content: '新昌县',

              levelNumber: 3
            },
            {
              content: '诸暨市',

              levelNumber: 3
            },
            {
              content: '嵊州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '金华市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '婺城区',

              levelNumber: 3
            },
            {
              content: '金东区',

              levelNumber: 3
            },
            {
              content: '武义县',

              levelNumber: 3
            },
            {
              content: '浦江县',

              levelNumber: 3
            },
            {
              content: '磐安县',

              levelNumber: 3
            },
            {
              content: '兰溪市',

              levelNumber: 3
            },
            {
              content: '义乌市',

              levelNumber: 3
            },
            {
              content: '东阳市',

              levelNumber: 3
            },
            {
              content: '永康市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '衢州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '柯城区',

              levelNumber: 3
            },
            {
              content: '衢江区',

              levelNumber: 3
            },
            {
              content: '常山县',

              levelNumber: 3
            },
            {
              content: '开化县',

              levelNumber: 3
            },
            {
              content: '龙游县',

              levelNumber: 3
            },
            {
              content: '江山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '舟山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '定海区',

              levelNumber: 3
            },
            {
              content: '普陀区',

              levelNumber: 3
            },
            {
              content: '岱山县',

              levelNumber: 3
            },
            {
              content: '嵊泗县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '台州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '椒江区',

              levelNumber: 3
            },
            {
              content: '黄岩区',

              levelNumber: 3
            },
            {
              content: '路桥区',

              levelNumber: 3
            },
            {
              content: '三门县',

              levelNumber: 3
            },
            {
              content: '天台县',

              levelNumber: 3
            },
            {
              content: '仙居县',

              levelNumber: 3
            },
            {
              content: '温岭市',

              levelNumber: 3
            },
            {
              content: '临海市',

              levelNumber: 3
            },
            {
              content: '玉环市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '丽水市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '莲都区',

              levelNumber: 3
            },
            {
              content: '青田县',

              levelNumber: 3
            },
            {
              content: '缙云县',

              levelNumber: 3
            },
            {
              content: '遂昌县',

              levelNumber: 3
            },
            {
              content: '松阳县',

              levelNumber: 3
            },
            {
              content: '云和县',

              levelNumber: 3
            },
            {
              content: '庆元县',

              levelNumber: 3
            },
            {
              content: '景宁畲族自治县',

              levelNumber: 3
            },
            {
              content: '龙泉市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '安徽省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '合肥市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '瑶海区',

              levelNumber: 3
            },
            {
              content: '庐阳区',

              levelNumber: 3
            },
            {
              content: '蜀山区',

              levelNumber: 3
            },
            {
              content: '包河区',

              levelNumber: 3
            },
            {
              content: '长丰县',

              levelNumber: 3
            },
            {
              content: '肥东县',

              levelNumber: 3
            },
            {
              content: '肥西县',

              levelNumber: 3
            },
            {
              content: '庐江县',

              levelNumber: 3
            },
            {
              content: '巢湖市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '芜湖市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '镜湖区',

              levelNumber: 3
            },
            {
              content: '鸠江区',

              levelNumber: 3
            },
            {
              content: '弋江区',

              levelNumber: 3
            },
            {
              content: '湾沚区',

              levelNumber: 3
            },
            {
              content: '繁昌区',

              levelNumber: 3
            },
            {
              content: '南陵县',

              levelNumber: 3
            },
            {
              content: '无为市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '蚌埠市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '龙子湖区',

              levelNumber: 3
            },
            {
              content: '蚌山区',

              levelNumber: 3
            },
            {
              content: '禹会区',

              levelNumber: 3
            },
            {
              content: '淮上区',

              levelNumber: 3
            },
            {
              content: '怀远县',

              levelNumber: 3
            },
            {
              content: '五河县',

              levelNumber: 3
            },
            {
              content: '固镇县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '淮南市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '大通区',

              levelNumber: 3
            },
            {
              content: '田家庵区',

              levelNumber: 3
            },
            {
              content: '谢家集区',

              levelNumber: 3
            },
            {
              content: '八公山区',

              levelNumber: 3
            },
            {
              content: '潘集区',

              levelNumber: 3
            },
            {
              content: '凤台县',

              levelNumber: 3
            },
            { content: '寿县', levelNumber: 3 }
          ]
        },
        {
          content: '马鞍山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '花山区',

              levelNumber: 3
            },
            {
              content: '雨山区',

              levelNumber: 3
            },
            {
              content: '博望区',

              levelNumber: 3
            },
            {
              content: '当涂县',

              levelNumber: 3
            },
            {
              content: '含山县',

              levelNumber: 3
            },
            { content: '和县', levelNumber: 3 }
          ]
        },
        {
          content: '淮北市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '杜集区',

              levelNumber: 3
            },
            {
              content: '相山区',

              levelNumber: 3
            },
            {
              content: '烈山区',

              levelNumber: 3
            },
            {
              content: '濉溪县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '铜陵市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '铜官区',

              levelNumber: 3
            },
            {
              content: '义安区',

              levelNumber: 3
            },
            {
              content: '郊区',

              levelNumber: 3
            },
            {
              content: '枞阳县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '安庆市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '迎江区',

              levelNumber: 3
            },
            {
              content: '大观区',

              levelNumber: 3
            },
            {
              content: '宜秀区',

              levelNumber: 3
            },
            {
              content: '怀宁县',

              levelNumber: 3
            },
            {
              content: '太湖县',

              levelNumber: 3
            },
            {
              content: '宿松县',

              levelNumber: 3
            },
            {
              content: '望江县',

              levelNumber: 3
            },
            {
              content: '岳西县',

              levelNumber: 3
            },
            {
              content: '桐城市',

              levelNumber: 3
            },
            {
              content: '潜山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黄山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '屯溪区',

              levelNumber: 3
            },
            {
              content: '黄山区',

              levelNumber: 3
            },
            {
              content: '徽州区',

              levelNumber: 3
            },
            {
              content: '歙县',

              levelNumber: 3
            },
            {
              content: '休宁县',

              levelNumber: 3
            },
            {
              content: '黟县',

              levelNumber: 3
            },
            {
              content: '祁门县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '滁州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '琅琊区',

              levelNumber: 3
            },
            {
              content: '南谯区',

              levelNumber: 3
            },
            {
              content: '来安县',

              levelNumber: 3
            },
            {
              content: '全椒县',

              levelNumber: 3
            },
            {
              content: '定远县',

              levelNumber: 3
            },
            {
              content: '凤阳县',

              levelNumber: 3
            },
            {
              content: '天长市',

              levelNumber: 3
            },
            {
              content: '明光市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阜阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '颍州区',

              levelNumber: 3
            },
            {
              content: '颍东区',

              levelNumber: 3
            },
            {
              content: '颍泉区',

              levelNumber: 3
            },
            {
              content: '临泉县',

              levelNumber: 3
            },
            {
              content: '太和县',

              levelNumber: 3
            },
            {
              content: '阜南县',

              levelNumber: 3
            },
            {
              content: '颍上县',

              levelNumber: 3
            },
            {
              content: '界首市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宿州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '埇桥区',

              levelNumber: 3
            },
            {
              content: '砀山县',

              levelNumber: 3
            },
            {
              content: '萧县',

              levelNumber: 3
            },
            {
              content: '灵璧县',

              levelNumber: 3
            },
            { content: '泗县', levelNumber: 3 }
          ]
        },
        {
          content: '六安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '金安区',

              levelNumber: 3
            },
            {
              content: '裕安区',

              levelNumber: 3
            },
            {
              content: '叶集区',

              levelNumber: 3
            },
            {
              content: '霍邱县',

              levelNumber: 3
            },
            {
              content: '舒城县',

              levelNumber: 3
            },
            {
              content: '金寨县',

              levelNumber: 3
            },
            {
              content: '霍山县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '亳州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '谯城区',

              levelNumber: 3
            },
            {
              content: '涡阳县',

              levelNumber: 3
            },
            {
              content: '蒙城县',

              levelNumber: 3
            },
            {
              content: '利辛县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '池州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '贵池区',

              levelNumber: 3
            },
            {
              content: '东至县',

              levelNumber: 3
            },
            {
              content: '石台县',

              levelNumber: 3
            },
            {
              content: '青阳县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宣城市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '宣州区',

              levelNumber: 3
            },
            {
              content: '郎溪县',

              levelNumber: 3
            },
            {
              content: '泾县',

              levelNumber: 3
            },
            {
              content: '绩溪县',

              levelNumber: 3
            },
            {
              content: '旌德县',

              levelNumber: 3
            },
            {
              content: '宁国市',

              levelNumber: 3
            },
            {
              content: '广德市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '福建省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '福州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '鼓楼区',

              levelNumber: 3
            },
            {
              content: '台江区',

              levelNumber: 3
            },
            {
              content: '仓山区',

              levelNumber: 3
            },
            {
              content: '马尾区',

              levelNumber: 3
            },
            {
              content: '晋安区',

              levelNumber: 3
            },
            {
              content: '长乐区',

              levelNumber: 3
            },
            {
              content: '闽侯县',

              levelNumber: 3
            },
            {
              content: '连江县',

              levelNumber: 3
            },
            {
              content: '罗源县',

              levelNumber: 3
            },
            {
              content: '闽清县',

              levelNumber: 3
            },
            {
              content: '永泰县',

              levelNumber: 3
            },
            {
              content: '平潭县',

              levelNumber: 3
            },
            {
              content: '福清市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '厦门市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '思明区',

              levelNumber: 3
            },
            {
              content: '海沧区',

              levelNumber: 3
            },
            {
              content: '湖里区',

              levelNumber: 3
            },
            {
              content: '集美区',

              levelNumber: 3
            },
            {
              content: '同安区',

              levelNumber: 3
            },
            {
              content: '翔安区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '莆田市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城厢区',

              levelNumber: 3
            },
            {
              content: '涵江区',

              levelNumber: 3
            },
            {
              content: '荔城区',

              levelNumber: 3
            },
            {
              content: '秀屿区',

              levelNumber: 3
            },
            {
              content: '仙游县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '三明市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '三元区',

              levelNumber: 3
            },
            {
              content: '沙县区',

              levelNumber: 3
            },
            {
              content: '明溪县',

              levelNumber: 3
            },
            {
              content: '清流县',

              levelNumber: 3
            },
            {
              content: '宁化县',

              levelNumber: 3
            },
            {
              content: '大田县',

              levelNumber: 3
            },
            {
              content: '尤溪县',

              levelNumber: 3
            },
            {
              content: '将乐县',

              levelNumber: 3
            },
            {
              content: '泰宁县',

              levelNumber: 3
            },
            {
              content: '建宁县',

              levelNumber: 3
            },
            {
              content: '永安市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '泉州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '鲤城区',

              levelNumber: 3
            },
            {
              content: '丰泽区',

              levelNumber: 3
            },
            {
              content: '洛江区',

              levelNumber: 3
            },
            {
              content: '泉港区',

              levelNumber: 3
            },
            {
              content: '惠安县',

              levelNumber: 3
            },
            {
              content: '安溪县',

              levelNumber: 3
            },
            {
              content: '永春县',

              levelNumber: 3
            },
            {
              content: '德化县',

              levelNumber: 3
            },
            {
              content: '金门县',

              levelNumber: 3
            },
            {
              content: '石狮市',

              levelNumber: 3
            },
            {
              content: '晋江市',

              levelNumber: 3
            },
            {
              content: '南安市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '漳州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '芗城区',

              levelNumber: 3
            },
            {
              content: '龙文区',

              levelNumber: 3
            },
            {
              content: '龙海区',

              levelNumber: 3
            },
            {
              content: '长泰区',

              levelNumber: 3
            },
            {
              content: '云霄县',

              levelNumber: 3
            },
            {
              content: '漳浦县',

              levelNumber: 3
            },
            {
              content: '诏安县',

              levelNumber: 3
            },
            {
              content: '东山县',

              levelNumber: 3
            },
            {
              content: '南靖县',

              levelNumber: 3
            },
            {
              content: '平和县',

              levelNumber: 3
            },
            {
              content: '华安县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '南平市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '延平区',

              levelNumber: 3
            },
            {
              content: '建阳区',

              levelNumber: 3
            },
            {
              content: '顺昌县',

              levelNumber: 3
            },
            {
              content: '浦城县',

              levelNumber: 3
            },
            {
              content: '光泽县',

              levelNumber: 3
            },
            {
              content: '松溪县',

              levelNumber: 3
            },
            {
              content: '政和县',

              levelNumber: 3
            },
            {
              content: '邵武市',

              levelNumber: 3
            },
            {
              content: '武夷山市',

              levelNumber: 3
            },
            {
              content: '建瓯市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '龙岩市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新罗区',

              levelNumber: 3
            },
            {
              content: '永定区',

              levelNumber: 3
            },
            {
              content: '长汀县',

              levelNumber: 3
            },
            {
              content: '上杭县',

              levelNumber: 3
            },
            {
              content: '武平县',

              levelNumber: 3
            },
            {
              content: '连城县',

              levelNumber: 3
            },
            {
              content: '漳平市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宁德市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '蕉城区',

              levelNumber: 3
            },
            {
              content: '霞浦县',

              levelNumber: 3
            },
            {
              content: '古田县',

              levelNumber: 3
            },
            {
              content: '屏南县',

              levelNumber: 3
            },
            {
              content: '寿宁县',

              levelNumber: 3
            },
            {
              content: '周宁县',

              levelNumber: 3
            },
            {
              content: '柘荣县',

              levelNumber: 3
            },
            {
              content: '福安市',

              levelNumber: 3
            },
            {
              content: '福鼎市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '江西省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '南昌市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东湖区',

              levelNumber: 3
            },
            {
              content: '西湖区',

              levelNumber: 3
            },
            {
              content: '青云谱区',

              levelNumber: 3
            },
            {
              content: '青山湖区',

              levelNumber: 3
            },
            {
              content: '新建区',

              levelNumber: 3
            },
            {
              content: '红谷滩区',

              levelNumber: 3
            },
            {
              content: '南昌县',

              levelNumber: 3
            },
            {
              content: '安义县',

              levelNumber: 3
            },
            {
              content: '进贤县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '景德镇市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '昌江区',

              levelNumber: 3
            },
            {
              content: '珠山区',

              levelNumber: 3
            },
            {
              content: '浮梁县',

              levelNumber: 3
            },
            {
              content: '乐平市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '萍乡市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '安源区',

              levelNumber: 3
            },
            {
              content: '湘东区',

              levelNumber: 3
            },
            {
              content: '莲花县',

              levelNumber: 3
            },
            {
              content: '上栗县',

              levelNumber: 3
            },
            {
              content: '芦溪县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '九江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '濂溪区',

              levelNumber: 3
            },
            {
              content: '浔阳区',

              levelNumber: 3
            },
            {
              content: '柴桑区',

              levelNumber: 3
            },
            {
              content: '武宁县',

              levelNumber: 3
            },
            {
              content: '修水县',

              levelNumber: 3
            },
            {
              content: '永修县',

              levelNumber: 3
            },
            {
              content: '德安县',

              levelNumber: 3
            },
            {
              content: '都昌县',

              levelNumber: 3
            },
            {
              content: '湖口县',

              levelNumber: 3
            },
            {
              content: '彭泽县',

              levelNumber: 3
            },
            {
              content: '瑞昌市',

              levelNumber: 3
            },
            {
              content: '共青城市',

              levelNumber: 3
            },
            {
              content: '庐山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '新余市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '渝水区',

              levelNumber: 3
            },
            {
              content: '分宜县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '鹰潭市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '月湖区',

              levelNumber: 3
            },
            {
              content: '余江区',

              levelNumber: 3
            },
            {
              content: '贵溪市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '赣州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '章贡区',

              levelNumber: 3
            },
            {
              content: '南康区',

              levelNumber: 3
            },
            {
              content: '赣县区',

              levelNumber: 3
            },
            {
              content: '信丰县',

              levelNumber: 3
            },
            {
              content: '大余县',

              levelNumber: 3
            },
            {
              content: '上犹县',

              levelNumber: 3
            },
            {
              content: '崇义县',

              levelNumber: 3
            },
            {
              content: '安远县',

              levelNumber: 3
            },
            {
              content: '定南县',

              levelNumber: 3
            },
            {
              content: '全南县',

              levelNumber: 3
            },
            {
              content: '宁都县',

              levelNumber: 3
            },
            {
              content: '于都县',

              levelNumber: 3
            },
            {
              content: '兴国县',

              levelNumber: 3
            },
            {
              content: '会昌县',

              levelNumber: 3
            },
            {
              content: '寻乌县',

              levelNumber: 3
            },
            {
              content: '石城县',

              levelNumber: 3
            },
            {
              content: '瑞金市',

              levelNumber: 3
            },
            {
              content: '龙南市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '吉安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '吉州区',

              levelNumber: 3
            },
            {
              content: '青原区',

              levelNumber: 3
            },
            {
              content: '吉安县',

              levelNumber: 3
            },
            {
              content: '吉水县',

              levelNumber: 3
            },
            {
              content: '峡江县',

              levelNumber: 3
            },
            {
              content: '新干县',

              levelNumber: 3
            },
            {
              content: '永丰县',

              levelNumber: 3
            },
            {
              content: '泰和县',

              levelNumber: 3
            },
            {
              content: '遂川县',

              levelNumber: 3
            },
            {
              content: '万安县',

              levelNumber: 3
            },
            {
              content: '安福县',

              levelNumber: 3
            },
            {
              content: '永新县',

              levelNumber: 3
            },
            {
              content: '井冈山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宜春市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '袁州区',

              levelNumber: 3
            },
            {
              content: '奉新县',

              levelNumber: 3
            },
            {
              content: '万载县',

              levelNumber: 3
            },
            {
              content: '上高县',

              levelNumber: 3
            },
            {
              content: '宜丰县',

              levelNumber: 3
            },
            {
              content: '靖安县',

              levelNumber: 3
            },
            {
              content: '铜鼓县',

              levelNumber: 3
            },
            {
              content: '丰城市',

              levelNumber: 3
            },
            {
              content: '樟树市',

              levelNumber: 3
            },
            {
              content: '高安市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '抚州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '临川区',

              levelNumber: 3
            },
            {
              content: '东乡区',

              levelNumber: 3
            },
            {
              content: '南城县',

              levelNumber: 3
            },
            {
              content: '黎川县',

              levelNumber: 3
            },
            {
              content: '南丰县',

              levelNumber: 3
            },
            {
              content: '崇仁县',

              levelNumber: 3
            },
            {
              content: '乐安县',

              levelNumber: 3
            },
            {
              content: '宜黄县',

              levelNumber: 3
            },
            {
              content: '金溪县',

              levelNumber: 3
            },
            {
              content: '资溪县',

              levelNumber: 3
            },
            {
              content: '广昌县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '上饶市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '信州区',

              levelNumber: 3
            },
            {
              content: '广丰区',

              levelNumber: 3
            },
            {
              content: '广信区',

              levelNumber: 3
            },
            {
              content: '玉山县',

              levelNumber: 3
            },
            {
              content: '铅山县',

              levelNumber: 3
            },
            {
              content: '横峰县',

              levelNumber: 3
            },
            {
              content: '弋阳县',

              levelNumber: 3
            },
            {
              content: '余干县',

              levelNumber: 3
            },
            {
              content: '鄱阳县',

              levelNumber: 3
            },
            {
              content: '万年县',

              levelNumber: 3
            },
            {
              content: '婺源县',

              levelNumber: 3
            },
            {
              content: '德兴市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '山东省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '济南市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '历下区',

              levelNumber: 3
            },
            {
              content: '市中区',

              levelNumber: 3
            },
            {
              content: '槐荫区',

              levelNumber: 3
            },
            {
              content: '天桥区',

              levelNumber: 3
            },
            {
              content: '历城区',

              levelNumber: 3
            },
            {
              content: '长清区',

              levelNumber: 3
            },
            {
              content: '章丘区',

              levelNumber: 3
            },
            {
              content: '济阳区',

              levelNumber: 3
            },
            {
              content: '莱芜区',

              levelNumber: 3
            },
            {
              content: '钢城区',

              levelNumber: 3
            },
            {
              content: '平阴县',

              levelNumber: 3
            },
            {
              content: '商河县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '青岛市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '市南区',

              levelNumber: 3
            },
            {
              content: '市北区',

              levelNumber: 3
            },
            {
              content: '黄岛区',

              levelNumber: 3
            },
            {
              content: '崂山区',

              levelNumber: 3
            },
            {
              content: '李沧区',

              levelNumber: 3
            },
            {
              content: '城阳区',

              levelNumber: 3
            },
            {
              content: '即墨区',

              levelNumber: 3
            },
            {
              content: '胶州市',

              levelNumber: 3
            },
            {
              content: '平度市',

              levelNumber: 3
            },
            {
              content: '莱西市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '淄博市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '淄川区',

              levelNumber: 3
            },
            {
              content: '张店区',

              levelNumber: 3
            },
            {
              content: '博山区',

              levelNumber: 3
            },
            {
              content: '临淄区',

              levelNumber: 3
            },
            {
              content: '周村区',

              levelNumber: 3
            },
            {
              content: '桓台县',

              levelNumber: 3
            },
            {
              content: '高青县',

              levelNumber: 3
            },
            {
              content: '沂源县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '枣庄市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '市中区',

              levelNumber: 3
            },
            {
              content: '薛城区',

              levelNumber: 3
            },
            {
              content: '峄城区',

              levelNumber: 3
            },
            {
              content: '台儿庄区',

              levelNumber: 3
            },
            {
              content: '山亭区',

              levelNumber: 3
            },
            {
              content: '滕州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '东营市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东营区',

              levelNumber: 3
            },
            {
              content: '河口区',

              levelNumber: 3
            },
            {
              content: '垦利区',

              levelNumber: 3
            },
            {
              content: '利津县',

              levelNumber: 3
            },
            {
              content: '广饶县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '烟台市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '芝罘区',

              levelNumber: 3
            },
            {
              content: '福山区',

              levelNumber: 3
            },
            {
              content: '牟平区',

              levelNumber: 3
            },
            {
              content: '莱山区',

              levelNumber: 3
            },
            {
              content: '蓬莱区',

              levelNumber: 3
            },
            {
              content: '龙口市',

              levelNumber: 3
            },
            {
              content: '莱阳市',

              levelNumber: 3
            },
            {
              content: '莱州市',

              levelNumber: 3
            },
            {
              content: '招远市',

              levelNumber: 3
            },
            {
              content: '栖霞市',

              levelNumber: 3
            },
            {
              content: '海阳市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '潍坊市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '潍城区',

              levelNumber: 3
            },
            {
              content: '寒亭区',

              levelNumber: 3
            },
            {
              content: '坊子区',

              levelNumber: 3
            },
            {
              content: '奎文区',

              levelNumber: 3
            },
            {
              content: '临朐县',

              levelNumber: 3
            },
            {
              content: '昌乐县',

              levelNumber: 3
            },
            {
              content: '青州市',

              levelNumber: 3
            },
            {
              content: '诸城市',

              levelNumber: 3
            },
            {
              content: '寿光市',

              levelNumber: 3
            },
            {
              content: '安丘市',

              levelNumber: 3
            },
            {
              content: '高密市',

              levelNumber: 3
            },
            {
              content: '昌邑市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '济宁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '任城区',

              levelNumber: 3
            },
            {
              content: '兖州区',

              levelNumber: 3
            },
            {
              content: '微山县',

              levelNumber: 3
            },
            {
              content: '鱼台县',

              levelNumber: 3
            },
            {
              content: '金乡县',

              levelNumber: 3
            },
            {
              content: '嘉祥县',

              levelNumber: 3
            },
            {
              content: '汶上县',

              levelNumber: 3
            },
            {
              content: '泗水县',

              levelNumber: 3
            },
            {
              content: '梁山县',

              levelNumber: 3
            },
            {
              content: '曲阜市',

              levelNumber: 3
            },
            {
              content: '邹城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '泰安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '泰山区',

              levelNumber: 3
            },
            {
              content: '岱岳区',

              levelNumber: 3
            },
            {
              content: '宁阳县',

              levelNumber: 3
            },
            {
              content: '东平县',

              levelNumber: 3
            },
            {
              content: '新泰市',

              levelNumber: 3
            },
            {
              content: '肥城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '威海市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '环翠区',

              levelNumber: 3
            },
            {
              content: '文登区',

              levelNumber: 3
            },
            {
              content: '荣成市',

              levelNumber: 3
            },
            {
              content: '乳山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '日照市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东港区',

              levelNumber: 3
            },
            {
              content: '岚山区',

              levelNumber: 3
            },
            {
              content: '五莲县',

              levelNumber: 3
            },
            { content: '莒县', levelNumber: 3 }
          ]
        },
        {
          content: '临沂市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '兰山区',

              levelNumber: 3
            },
            {
              content: '罗庄区',

              levelNumber: 3
            },
            {
              content: '河东区',

              levelNumber: 3
            },
            {
              content: '沂南县',

              levelNumber: 3
            },
            {
              content: '郯城县',

              levelNumber: 3
            },
            {
              content: '沂水县',

              levelNumber: 3
            },
            {
              content: '兰陵县',

              levelNumber: 3
            },
            {
              content: '费县',

              levelNumber: 3
            },
            {
              content: '平邑县',

              levelNumber: 3
            },
            {
              content: '莒南县',

              levelNumber: 3
            },
            {
              content: '蒙阴县',

              levelNumber: 3
            },
            {
              content: '临沭县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '德州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '德城区',

              levelNumber: 3
            },
            {
              content: '陵城区',

              levelNumber: 3
            },
            {
              content: '宁津县',

              levelNumber: 3
            },
            {
              content: '庆云县',

              levelNumber: 3
            },
            {
              content: '临邑县',

              levelNumber: 3
            },
            {
              content: '齐河县',

              levelNumber: 3
            },
            {
              content: '平原县',

              levelNumber: 3
            },
            {
              content: '夏津县',

              levelNumber: 3
            },
            {
              content: '武城县',

              levelNumber: 3
            },
            {
              content: '乐陵市',

              levelNumber: 3
            },
            {
              content: '禹城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '聊城市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东昌府区',

              levelNumber: 3
            },
            {
              content: '茌平区',

              levelNumber: 3
            },
            {
              content: '阳谷县',

              levelNumber: 3
            },
            {
              content: '莘县',

              levelNumber: 3
            },
            {
              content: '东阿县',

              levelNumber: 3
            },
            {
              content: '冠县',

              levelNumber: 3
            },
            {
              content: '高唐县',

              levelNumber: 3
            },
            {
              content: '临清市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '滨州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '滨城区',

              levelNumber: 3
            },
            {
              content: '沾化区',

              levelNumber: 3
            },
            {
              content: '惠民县',

              levelNumber: 3
            },
            {
              content: '阳信县',

              levelNumber: 3
            },
            {
              content: '无棣县',

              levelNumber: 3
            },
            {
              content: '博兴县',

              levelNumber: 3
            },
            {
              content: '邹平市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '菏泽市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '牡丹区',

              levelNumber: 3
            },
            {
              content: '定陶区',

              levelNumber: 3
            },
            {
              content: '曹县',

              levelNumber: 3
            },
            {
              content: '单县',

              levelNumber: 3
            },
            {
              content: '成武县',

              levelNumber: 3
            },
            {
              content: '巨野县',

              levelNumber: 3
            },
            {
              content: '郓城县',

              levelNumber: 3
            },
            {
              content: '鄄城县',

              levelNumber: 3
            },
            {
              content: '东明县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '河南省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '郑州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '中原区',

              levelNumber: 3
            },
            {
              content: '二七区',

              levelNumber: 3
            },
            {
              content: '管城回族区',

              levelNumber: 3
            },
            {
              content: '金水区',

              levelNumber: 3
            },
            {
              content: '上街区',

              levelNumber: 3
            },
            {
              content: '惠济区',

              levelNumber: 3
            },
            {
              content: '中牟县',

              levelNumber: 3
            },
            {
              content: '巩义市',

              levelNumber: 3
            },
            {
              content: '荥阳市',

              levelNumber: 3
            },
            {
              content: '新密市',

              levelNumber: 3
            },
            {
              content: '新郑市',

              levelNumber: 3
            },
            {
              content: '登封市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '开封市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '龙亭区',

              levelNumber: 3
            },
            {
              content: '顺河回族区',

              levelNumber: 3
            },
            {
              content: '鼓楼区',

              levelNumber: 3
            },
            {
              content: '禹王台区',

              levelNumber: 3
            },
            {
              content: '祥符区',

              levelNumber: 3
            },
            {
              content: '杞县',

              levelNumber: 3
            },
            {
              content: '通许县',

              levelNumber: 3
            },
            {
              content: '尉氏县',

              levelNumber: 3
            },
            {
              content: '兰考县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '洛阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '老城区',

              levelNumber: 3
            },
            {
              content: '西工区',

              levelNumber: 3
            },
            {
              content: '瀍河回族区',

              levelNumber: 3
            },
            {
              content: '涧西区',

              levelNumber: 3
            },
            {
              content: '偃师区',

              levelNumber: 3
            },
            {
              content: '孟津区',

              levelNumber: 3
            },
            {
              content: '洛龙区',

              levelNumber: 3
            },
            {
              content: '新安县',

              levelNumber: 3
            },
            {
              content: '栾川县',

              levelNumber: 3
            },
            {
              content: '嵩县',

              levelNumber: 3
            },
            {
              content: '汝阳县',

              levelNumber: 3
            },
            {
              content: '宜阳县',

              levelNumber: 3
            },
            {
              content: '洛宁县',

              levelNumber: 3
            },
            {
              content: '伊川县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '平顶山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新华区',

              levelNumber: 3
            },
            {
              content: '卫东区',

              levelNumber: 3
            },
            {
              content: '石龙区',

              levelNumber: 3
            },
            {
              content: '湛河区',

              levelNumber: 3
            },
            {
              content: '宝丰县',

              levelNumber: 3
            },
            {
              content: '叶县',

              levelNumber: 3
            },
            {
              content: '鲁山县',

              levelNumber: 3
            },
            {
              content: '郏县',

              levelNumber: 3
            },
            {
              content: '舞钢市',

              levelNumber: 3
            },
            {
              content: '汝州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '安阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '文峰区',

              levelNumber: 3
            },
            {
              content: '北关区',

              levelNumber: 3
            },
            {
              content: '殷都区',

              levelNumber: 3
            },
            {
              content: '龙安区',

              levelNumber: 3
            },
            {
              content: '安阳县',

              levelNumber: 3
            },
            {
              content: '汤阴县',

              levelNumber: 3
            },
            {
              content: '滑县',

              levelNumber: 3
            },
            {
              content: '内黄县',

              levelNumber: 3
            },
            {
              content: '林州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '鹤壁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '鹤山区',

              levelNumber: 3
            },
            {
              content: '山城区',

              levelNumber: 3
            },
            {
              content: '淇滨区',

              levelNumber: 3
            },
            {
              content: '浚县',

              levelNumber: 3
            },
            { content: '淇县', levelNumber: 3 }
          ]
        },
        {
          content: '新乡市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '红旗区',

              levelNumber: 3
            },
            {
              content: '卫滨区',

              levelNumber: 3
            },
            {
              content: '凤泉区',

              levelNumber: 3
            },
            {
              content: '牧野区',

              levelNumber: 3
            },
            {
              content: '新乡县',

              levelNumber: 3
            },
            {
              content: '获嘉县',

              levelNumber: 3
            },
            {
              content: '原阳县',

              levelNumber: 3
            },
            {
              content: '延津县',

              levelNumber: 3
            },
            {
              content: '封丘县',

              levelNumber: 3
            },
            {
              content: '卫辉市',

              levelNumber: 3
            },
            {
              content: '辉县市',

              levelNumber: 3
            },
            {
              content: '长垣市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '焦作市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '解放区',

              levelNumber: 3
            },
            {
              content: '中站区',

              levelNumber: 3
            },
            {
              content: '马村区',

              levelNumber: 3
            },
            {
              content: '山阳区',

              levelNumber: 3
            },
            {
              content: '修武县',

              levelNumber: 3
            },
            {
              content: '博爱县',

              levelNumber: 3
            },
            {
              content: '武陟县',

              levelNumber: 3
            },
            {
              content: '温县',

              levelNumber: 3
            },
            {
              content: '沁阳市',

              levelNumber: 3
            },
            {
              content: '孟州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '濮阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '华龙区',

              levelNumber: 3
            },
            {
              content: '清丰县',

              levelNumber: 3
            },
            {
              content: '南乐县',

              levelNumber: 3
            },
            {
              content: '范县',

              levelNumber: 3
            },
            {
              content: '台前县',

              levelNumber: 3
            },
            {
              content: '濮阳县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '许昌市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '魏都区',

              levelNumber: 3
            },
            {
              content: '建安区',

              levelNumber: 3
            },
            {
              content: '鄢陵县',

              levelNumber: 3
            },
            {
              content: '襄城县',

              levelNumber: 3
            },
            {
              content: '禹州市',

              levelNumber: 3
            },
            {
              content: '长葛市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '漯河市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '源汇区',

              levelNumber: 3
            },
            {
              content: '郾城区',

              levelNumber: 3
            },
            {
              content: '召陵区',

              levelNumber: 3
            },
            {
              content: '舞阳县',

              levelNumber: 3
            },
            {
              content: '临颍县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '三门峡市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '湖滨区',

              levelNumber: 3
            },
            {
              content: '陕州区',

              levelNumber: 3
            },
            {
              content: '渑池县',

              levelNumber: 3
            },
            {
              content: '卢氏县',

              levelNumber: 3
            },
            {
              content: '义马市',

              levelNumber: 3
            },
            {
              content: '灵宝市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '南阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '宛城区',

              levelNumber: 3
            },
            {
              content: '卧龙区',

              levelNumber: 3
            },
            {
              content: '南召县',

              levelNumber: 3
            },
            {
              content: '方城县',

              levelNumber: 3
            },
            {
              content: '西峡县',

              levelNumber: 3
            },
            {
              content: '镇平县',

              levelNumber: 3
            },
            {
              content: '内乡县',

              levelNumber: 3
            },
            {
              content: '淅川县',

              levelNumber: 3
            },
            {
              content: '社旗县',

              levelNumber: 3
            },
            {
              content: '唐河县',

              levelNumber: 3
            },
            {
              content: '新野县',

              levelNumber: 3
            },
            {
              content: '桐柏县',

              levelNumber: 3
            },
            {
              content: '邓州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '商丘市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '梁园区',

              levelNumber: 3
            },
            {
              content: '睢阳区',

              levelNumber: 3
            },
            {
              content: '民权县',

              levelNumber: 3
            },
            {
              content: '睢县',

              levelNumber: 3
            },
            {
              content: '宁陵县',

              levelNumber: 3
            },
            {
              content: '柘城县',

              levelNumber: 3
            },
            {
              content: '虞城县',

              levelNumber: 3
            },
            {
              content: '夏邑县',

              levelNumber: 3
            },
            {
              content: '永城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '信阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '浉河区',

              levelNumber: 3
            },
            {
              content: '平桥区',

              levelNumber: 3
            },
            {
              content: '罗山县',

              levelNumber: 3
            },
            {
              content: '光山县',

              levelNumber: 3
            },
            {
              content: '新县',

              levelNumber: 3
            },
            {
              content: '商城县',

              levelNumber: 3
            },
            {
              content: '固始县',

              levelNumber: 3
            },
            {
              content: '潢川县',

              levelNumber: 3
            },
            {
              content: '淮滨县',

              levelNumber: 3
            },
            { content: '息县', levelNumber: 3 }
          ]
        },
        {
          content: '周口市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '川汇区',

              levelNumber: 3
            },
            {
              content: '淮阳区',

              levelNumber: 3
            },
            {
              content: '扶沟县',

              levelNumber: 3
            },
            {
              content: '西华县',

              levelNumber: 3
            },
            {
              content: '商水县',

              levelNumber: 3
            },
            {
              content: '沈丘县',

              levelNumber: 3
            },
            {
              content: '郸城县',

              levelNumber: 3
            },
            {
              content: '太康县',

              levelNumber: 3
            },
            {
              content: '鹿邑县',

              levelNumber: 3
            },
            {
              content: '项城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '驻马店市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '驿城区',

              levelNumber: 3
            },
            {
              content: '西平县',

              levelNumber: 3
            },
            {
              content: '上蔡县',

              levelNumber: 3
            },
            {
              content: '平舆县',

              levelNumber: 3
            },
            {
              content: '正阳县',

              levelNumber: 3
            },
            {
              content: '确山县',

              levelNumber: 3
            },
            {
              content: '泌阳县',

              levelNumber: 3
            },
            {
              content: '汝南县',

              levelNumber: 3
            },
            {
              content: '遂平县',

              levelNumber: 3
            },
            {
              content: '新蔡县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '济源市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '济源市坡头镇',

              levelNumber: 3
            },
            {
              content: '济源市梨林镇',

              levelNumber: 3
            },
            {
              content: '济源市思礼镇',

              levelNumber: 3
            },
            {
              content: '济源市大峪镇',

              levelNumber: 3
            },
            {
              content: '济源市五龙口镇',

              levelNumber: 3
            },
            {
              content: '济源市王屋镇',

              levelNumber: 3
            },
            {
              content: '济源市轵城镇',

              levelNumber: 3
            },
            {
              content: '济源市玉泉街道',

              levelNumber: 3
            },
            {
              content: '济源市济水街道',

              levelNumber: 3
            },
            {
              content: '济源市沁园街道',

              levelNumber: 3
            },
            {
              content: '济源市下冶镇',

              levelNumber: 3
            },
            {
              content: '济源市克井镇',

              levelNumber: 3
            },
            {
              content: '济源市天坛街道',

              levelNumber: 3
            },
            {
              content: '济源市邵原镇',

              levelNumber: 3
            },
            {
              content: '济源市北海街道',

              levelNumber: 3
            },
            {
              content: '济源市承留镇',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '湖北省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '武汉市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '江岸区',

              levelNumber: 3
            },
            {
              content: '江汉区',

              levelNumber: 3
            },
            {
              content: '硚口区',

              levelNumber: 3
            },
            {
              content: '汉阳区',

              levelNumber: 3
            },
            {
              content: '武昌区',

              levelNumber: 3
            },
            {
              content: '青山区',

              levelNumber: 3
            },
            {
              content: '洪山区',

              levelNumber: 3
            },
            {
              content: '东西湖区',

              levelNumber: 3
            },
            {
              content: '汉南区',

              levelNumber: 3
            },
            {
              content: '蔡甸区',

              levelNumber: 3
            },
            {
              content: '江夏区',

              levelNumber: 3
            },
            {
              content: '黄陂区',

              levelNumber: 3
            },
            {
              content: '新洲区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黄石市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '黄石港区',

              levelNumber: 3
            },
            {
              content: '西塞山区',

              levelNumber: 3
            },
            {
              content: '下陆区',

              levelNumber: 3
            },
            {
              content: '铁山区',

              levelNumber: 3
            },
            {
              content: '阳新县',

              levelNumber: 3
            },
            {
              content: '大冶市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '十堰市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '茅箭区',

              levelNumber: 3
            },
            {
              content: '张湾区',

              levelNumber: 3
            },
            {
              content: '郧阳区',

              levelNumber: 3
            },
            {
              content: '郧西县',

              levelNumber: 3
            },
            {
              content: '竹山县',

              levelNumber: 3
            },
            {
              content: '竹溪县',

              levelNumber: 3
            },
            {
              content: '房县',

              levelNumber: 3
            },
            {
              content: '丹江口市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宜昌市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '西陵区',

              levelNumber: 3
            },
            {
              content: '伍家岗区',

              levelNumber: 3
            },
            {
              content: '点军区',

              levelNumber: 3
            },
            {
              content: '猇亭区',

              levelNumber: 3
            },
            {
              content: '夷陵区',

              levelNumber: 3
            },
            {
              content: '远安县',

              levelNumber: 3
            },
            {
              content: '兴山县',

              levelNumber: 3
            },
            {
              content: '秭归县',

              levelNumber: 3
            },
            {
              content: '长阳土家族自治县',

              levelNumber: 3
            },
            {
              content: '五峰土家族自治县',

              levelNumber: 3
            },
            {
              content: '宜都市',

              levelNumber: 3
            },
            {
              content: '当阳市',

              levelNumber: 3
            },
            {
              content: '枝江市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '襄阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '襄城区',

              levelNumber: 3
            },
            {
              content: '樊城区',

              levelNumber: 3
            },
            {
              content: '襄州区',

              levelNumber: 3
            },
            {
              content: '南漳县',

              levelNumber: 3
            },
            {
              content: '谷城县',

              levelNumber: 3
            },
            {
              content: '保康县',

              levelNumber: 3
            },
            {
              content: '老河口市',

              levelNumber: 3
            },
            {
              content: '枣阳市',

              levelNumber: 3
            },
            {
              content: '宜城市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '鄂州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '梁子湖区',

              levelNumber: 3
            },
            {
              content: '华容区',

              levelNumber: 3
            },
            {
              content: '鄂城区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '荆门市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东宝区',

              levelNumber: 3
            },
            {
              content: '掇刀区',

              levelNumber: 3
            },
            {
              content: '沙洋县',

              levelNumber: 3
            },
            {
              content: '钟祥市',

              levelNumber: 3
            },
            {
              content: '京山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '孝感市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '孝南区',

              levelNumber: 3
            },
            {
              content: '孝昌县',

              levelNumber: 3
            },
            {
              content: '大悟县',

              levelNumber: 3
            },
            {
              content: '云梦县',

              levelNumber: 3
            },
            {
              content: '应城市',

              levelNumber: 3
            },
            {
              content: '安陆市',

              levelNumber: 3
            },
            {
              content: '汉川市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '荆州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '沙市区',

              levelNumber: 3
            },
            {
              content: '荆州区',

              levelNumber: 3
            },
            {
              content: '公安县',

              levelNumber: 3
            },
            {
              content: '江陵县',

              levelNumber: 3
            },
            {
              content: '石首市',

              levelNumber: 3
            },
            {
              content: '洪湖市',

              levelNumber: 3
            },
            {
              content: '松滋市',

              levelNumber: 3
            },
            {
              content: '监利市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黄冈市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '黄州区',

              levelNumber: 3
            },
            {
              content: '团风县',

              levelNumber: 3
            },
            {
              content: '红安县',

              levelNumber: 3
            },
            {
              content: '罗田县',

              levelNumber: 3
            },
            {
              content: '英山县',

              levelNumber: 3
            },
            {
              content: '浠水县',

              levelNumber: 3
            },
            {
              content: '蕲春县',

              levelNumber: 3
            },
            {
              content: '黄梅县',

              levelNumber: 3
            },
            {
              content: '麻城市',

              levelNumber: 3
            },
            {
              content: '武穴市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '咸宁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '咸安区',

              levelNumber: 3
            },
            {
              content: '嘉鱼县',

              levelNumber: 3
            },
            {
              content: '通城县',

              levelNumber: 3
            },
            {
              content: '崇阳县',

              levelNumber: 3
            },
            {
              content: '通山县',

              levelNumber: 3
            },
            {
              content: '赤壁市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '随州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '曾都区',

              levelNumber: 3
            },
            {
              content: '随县',

              levelNumber: 3
            },
            {
              content: '广水市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '恩施土家族苗族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '恩施市',

              levelNumber: 3
            },
            {
              content: '利川市',

              levelNumber: 3
            },
            {
              content: '建始县',

              levelNumber: 3
            },
            {
              content: '巴东县',

              levelNumber: 3
            },
            {
              content: '宣恩县',

              levelNumber: 3
            },
            {
              content: '咸丰县',

              levelNumber: 3
            },
            {
              content: '来凤县',

              levelNumber: 3
            },
            {
              content: '鹤峰县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '仙桃市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '畜禽良种场',

              levelNumber: 3
            },
            {
              content: '工业园区',

              levelNumber: 3
            },
            {
              content: '豆河镇',

              levelNumber: 3
            },
            {
              content: '沙湖镇',

              levelNumber: 3
            },
            {
              content: '通海口镇',

              levelNumber: 3
            },
            {
              content: '胡场镇',

              levelNumber: 3
            },
            {
              content: '长倘口镇',

              levelNumber: 3
            },
            {
              content: '五湖渔场',

              levelNumber: 3
            },
            {
              content: '干河街道',

              levelNumber: 3
            },
            {
              content: '杨林尾镇',

              levelNumber: 3
            },
            {
              content: '西流河镇',

              levelNumber: 3
            },
            {
              content: '赵西垸林场',

              levelNumber: 3
            },
            {
              content: '九合垸原种场',

              levelNumber: 3
            },
            {
              content: '彭场镇',

              levelNumber: 3
            },
            {
              content: '沔城回族镇',

              levelNumber: 3
            },
            {
              content: '龙华山街道',

              levelNumber: 3
            },
            {
              content: '沙湖原种场',

              levelNumber: 3
            },
            {
              content: '陈场镇',

              levelNumber: 3
            },
            {
              content: '郑场镇',

              levelNumber: 3
            },
            {
              content: '郭河镇',

              levelNumber: 3
            },
            {
              content: '排湖风景区',

              levelNumber: 3
            },
            {
              content: '沙嘴街道',

              levelNumber: 3
            },
            {
              content: '毛嘴镇',

              levelNumber: 3
            },
            {
              content: '张沟镇',

              levelNumber: 3
            },
            {
              content: '三伏潭镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '潜江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '积玉口镇',

              levelNumber: 3
            },
            {
              content: '泰丰街道',

              levelNumber: 3
            },
            {
              content: '广华街道',

              levelNumber: 3
            },
            {
              content: '周矶管理区',

              levelNumber: 3
            },
            {
              content: '潜江经济开发区',

              levelNumber: 3
            },
            {
              content: '高场街道',

              levelNumber: 3
            },
            {
              content: '周矶街道',

              levelNumber: 3
            },
            {
              content: '总口管理区',

              levelNumber: 3
            },
            {
              content: '王场镇',

              levelNumber: 3
            },
            {
              content: '运粮湖管理区',

              levelNumber: 3
            },
            {
              content: '园林街道',

              levelNumber: 3
            },
            {
              content: '白鹭湖管理区',

              levelNumber: 3
            },
            {
              content: '竹根滩镇',

              levelNumber: 3
            },
            {
              content: '渔洋镇',

              levelNumber: 3
            },
            {
              content: '熊口镇',

              levelNumber: 3
            },
            {
              content: '江汉石油管理局',

              levelNumber: 3
            },
            {
              content: '熊口管理区',

              levelNumber: 3
            },
            {
              content: '后湖管理区',

              levelNumber: 3
            },
            {
              content: '张金镇',

              levelNumber: 3
            },
            {
              content: '杨市街道',

              levelNumber: 3
            },
            {
              content: '老新镇',

              levelNumber: 3
            },
            {
              content: '浩口镇',

              levelNumber: 3
            },
            {
              content: '高石碑镇',

              levelNumber: 3
            },
            {
              content: '浩口原种场',

              levelNumber: 3
            },
            {
              content: '龙湾镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '天门市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '胡市镇',

              levelNumber: 3
            },
            {
              content: '黄潭镇',

              levelNumber: 3
            },
            {
              content: '多祥镇',

              levelNumber: 3
            },
            {
              content: '沉湖管委会',

              levelNumber: 3
            },
            {
              content: '干驿镇',

              levelNumber: 3
            },
            {
              content: '横林镇',

              levelNumber: 3
            },
            {
              content: '马湾镇',

              levelNumber: 3
            },
            {
              content: '蒋湖农场',

              levelNumber: 3
            },
            {
              content: '小板镇',

              levelNumber: 3
            },
            {
              content: '多宝镇',

              levelNumber: 3
            },
            {
              content: '岳口镇',

              levelNumber: 3
            },
            {
              content: '蒋场镇',

              levelNumber: 3
            },
            {
              content: '石家河镇',

              levelNumber: 3
            },
            {
              content: '彭市镇',

              levelNumber: 3
            },
            {
              content: '佛子山镇',

              levelNumber: 3
            },
            {
              content: '九真镇',

              levelNumber: 3
            },
            {
              content: '竟陵街道',

              levelNumber: 3
            },
            {
              content: '候口街道',

              levelNumber: 3
            },
            {
              content: '麻洋镇',

              levelNumber: 3
            },
            {
              content: '杨林街道',

              levelNumber: 3
            },
            {
              content: '汪场镇',

              levelNumber: 3
            },
            {
              content: '白茅湖农场',

              levelNumber: 3
            },
            {
              content: '张港镇',

              levelNumber: 3
            },
            {
              content: '渔薪镇',

              levelNumber: 3
            },
            {
              content: '皂市镇',

              levelNumber: 3
            },
            {
              content: '拖市镇',

              levelNumber: 3
            },
            {
              content: '净潭乡',

              levelNumber: 3
            },
            {
              content: '卢市镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '神农架林区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '木鱼镇',

              levelNumber: 3
            },
            {
              content: '下谷坪土家族乡',

              levelNumber: 3
            },
            {
              content: '新华镇',

              levelNumber: 3
            },
            {
              content: '大九湖镇',

              levelNumber: 3
            },
            {
              content: '松柏镇',

              levelNumber: 3
            },
            {
              content: '宋洛乡',

              levelNumber: 3
            },
            {
              content: '红坪镇',

              levelNumber: 3
            },
            {
              content: '阳日镇',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '湖南省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '长沙市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '芙蓉区',

              levelNumber: 3
            },
            {
              content: '天心区',

              levelNumber: 3
            },
            {
              content: '岳麓区',

              levelNumber: 3
            },
            {
              content: '开福区',

              levelNumber: 3
            },
            {
              content: '雨花区',

              levelNumber: 3
            },
            {
              content: '望城区',

              levelNumber: 3
            },
            {
              content: '长沙县',

              levelNumber: 3
            },
            {
              content: '浏阳市',

              levelNumber: 3
            },
            {
              content: '宁乡市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '株洲市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '荷塘区',

              levelNumber: 3
            },
            {
              content: '芦淞区',

              levelNumber: 3
            },
            {
              content: '石峰区',

              levelNumber: 3
            },
            {
              content: '天元区',

              levelNumber: 3
            },
            {
              content: '渌口区',

              levelNumber: 3
            },
            {
              content: '攸县',

              levelNumber: 3
            },
            {
              content: '茶陵县',

              levelNumber: 3
            },
            {
              content: '炎陵县',

              levelNumber: 3
            },
            {
              content: '醴陵市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '湘潭市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '雨湖区',

              levelNumber: 3
            },
            {
              content: '岳塘区',

              levelNumber: 3
            },
            {
              content: '湘潭县',

              levelNumber: 3
            },
            {
              content: '湘乡市',

              levelNumber: 3
            },
            {
              content: '韶山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '衡阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '珠晖区',

              levelNumber: 3
            },
            {
              content: '雁峰区',

              levelNumber: 3
            },
            {
              content: '石鼓区',

              levelNumber: 3
            },
            {
              content: '蒸湘区',

              levelNumber: 3
            },
            {
              content: '南岳区',

              levelNumber: 3
            },
            {
              content: '衡阳县',

              levelNumber: 3
            },
            {
              content: '衡南县',

              levelNumber: 3
            },
            {
              content: '衡山县',

              levelNumber: 3
            },
            {
              content: '衡东县',

              levelNumber: 3
            },
            {
              content: '祁东县',

              levelNumber: 3
            },
            {
              content: '耒阳市',

              levelNumber: 3
            },
            {
              content: '常宁市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '邵阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '双清区',

              levelNumber: 3
            },
            {
              content: '大祥区',

              levelNumber: 3
            },
            {
              content: '北塔区',

              levelNumber: 3
            },
            {
              content: '新邵县',

              levelNumber: 3
            },
            {
              content: '邵阳县',

              levelNumber: 3
            },
            {
              content: '隆回县',

              levelNumber: 3
            },
            {
              content: '洞口县',

              levelNumber: 3
            },
            {
              content: '绥宁县',

              levelNumber: 3
            },
            {
              content: '新宁县',

              levelNumber: 3
            },
            {
              content: '城步苗族自治县',

              levelNumber: 3
            },
            {
              content: '武冈市',

              levelNumber: 3
            },
            {
              content: '邵东市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '岳阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '岳阳楼区',

              levelNumber: 3
            },
            {
              content: '云溪区',

              levelNumber: 3
            },
            {
              content: '君山区',

              levelNumber: 3
            },
            {
              content: '岳阳县',

              levelNumber: 3
            },
            {
              content: '华容县',

              levelNumber: 3
            },
            {
              content: '湘阴县',

              levelNumber: 3
            },
            {
              content: '平江县',

              levelNumber: 3
            },
            {
              content: '汨罗市',

              levelNumber: 3
            },
            {
              content: '临湘市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '常德市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '武陵区',

              levelNumber: 3
            },
            {
              content: '鼎城区',

              levelNumber: 3
            },
            {
              content: '安乡县',

              levelNumber: 3
            },
            {
              content: '汉寿县',

              levelNumber: 3
            },
            {
              content: '澧县',

              levelNumber: 3
            },
            {
              content: '临澧县',

              levelNumber: 3
            },
            {
              content: '桃源县',

              levelNumber: 3
            },
            {
              content: '石门县',

              levelNumber: 3
            },
            {
              content: '津市市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '张家界市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '永定区',

              levelNumber: 3
            },
            {
              content: '武陵源区',

              levelNumber: 3
            },
            {
              content: '慈利县',

              levelNumber: 3
            },
            {
              content: '桑植县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '益阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '资阳区',

              levelNumber: 3
            },
            {
              content: '赫山区',

              levelNumber: 3
            },
            {
              content: '南县',

              levelNumber: 3
            },
            {
              content: '桃江县',

              levelNumber: 3
            },
            {
              content: '安化县',

              levelNumber: 3
            },
            {
              content: '沅江市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '郴州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '北湖区',

              levelNumber: 3
            },
            {
              content: '苏仙区',

              levelNumber: 3
            },
            {
              content: '桂阳县',

              levelNumber: 3
            },
            {
              content: '宜章县',

              levelNumber: 3
            },
            {
              content: '永兴县',

              levelNumber: 3
            },
            {
              content: '嘉禾县',

              levelNumber: 3
            },
            {
              content: '临武县',

              levelNumber: 3
            },
            {
              content: '汝城县',

              levelNumber: 3
            },
            {
              content: '桂东县',

              levelNumber: 3
            },
            {
              content: '安仁县',

              levelNumber: 3
            },
            {
              content: '资兴市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '永州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '零陵区',

              levelNumber: 3
            },
            {
              content: '冷水滩区',

              levelNumber: 3
            },
            {
              content: '祁阳市',

              levelNumber: 3
            },
            {
              content: '东安县',

              levelNumber: 3
            },
            {
              content: '双牌县',

              levelNumber: 3
            },
            {
              content: '道县',

              levelNumber: 3
            },
            {
              content: '江永县',

              levelNumber: 3
            },
            {
              content: '宁远县',

              levelNumber: 3
            },
            {
              content: '蓝山县',

              levelNumber: 3
            },
            {
              content: '新田县',

              levelNumber: 3
            },
            {
              content: '江华瑶族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '怀化市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '鹤城区',

              levelNumber: 3
            },
            {
              content: '中方县',

              levelNumber: 3
            },
            {
              content: '沅陵县',

              levelNumber: 3
            },
            {
              content: '辰溪县',

              levelNumber: 3
            },
            {
              content: '溆浦县',

              levelNumber: 3
            },
            {
              content: '会同县',

              levelNumber: 3
            },
            {
              content: '麻阳苗族自治县',

              levelNumber: 3
            },
            {
              content: '新晃侗族自治县',

              levelNumber: 3
            },
            {
              content: '芷江侗族自治县',

              levelNumber: 3
            },
            {
              content: '靖州苗族侗族自治县',

              levelNumber: 3
            },
            {
              content: '通道侗族自治县',

              levelNumber: 3
            },
            {
              content: '洪江市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '娄底市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '娄星区',

              levelNumber: 3
            },
            {
              content: '双峰县',

              levelNumber: 3
            },
            {
              content: '新化县',

              levelNumber: 3
            },
            {
              content: '冷水江市',

              levelNumber: 3
            },
            {
              content: '涟源市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '湘西土家族苗族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '吉首市',

              levelNumber: 3
            },
            {
              content: '泸溪县',

              levelNumber: 3
            },
            {
              content: '凤凰县',

              levelNumber: 3
            },
            {
              content: '花垣县',

              levelNumber: 3
            },
            {
              content: '保靖县',

              levelNumber: 3
            },
            {
              content: '古丈县',

              levelNumber: 3
            },
            {
              content: '永顺县',

              levelNumber: 3
            },
            {
              content: '龙山县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '广东省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '广州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '荔湾区',

              levelNumber: 3
            },
            {
              content: '越秀区',

              levelNumber: 3
            },
            {
              content: '海珠区',

              levelNumber: 3
            },
            {
              content: '天河区',

              levelNumber: 3
            },
            {
              content: '白云区',

              levelNumber: 3
            },
            {
              content: '黄埔区',

              levelNumber: 3
            },
            {
              content: '番禺区',

              levelNumber: 3
            },
            {
              content: '花都区',

              levelNumber: 3
            },
            {
              content: '南沙区',

              levelNumber: 3
            },
            {
              content: '从化区',

              levelNumber: 3
            },
            {
              content: '增城区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '韶关市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '武江区',

              levelNumber: 3
            },
            {
              content: '浈江区',

              levelNumber: 3
            },
            {
              content: '曲江区',

              levelNumber: 3
            },
            {
              content: '始兴县',

              levelNumber: 3
            },
            {
              content: '仁化县',

              levelNumber: 3
            },
            {
              content: '翁源县',

              levelNumber: 3
            },
            {
              content: '乳源瑶族自治县',

              levelNumber: 3
            },
            {
              content: '新丰县',

              levelNumber: 3
            },
            {
              content: '乐昌市',

              levelNumber: 3
            },
            {
              content: '南雄市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '深圳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '罗湖区',

              levelNumber: 3
            },
            {
              content: '福田区',

              levelNumber: 3
            },
            {
              content: '南山区',

              levelNumber: 3
            },
            {
              content: '宝安区',

              levelNumber: 3
            },
            {
              content: '龙岗区',

              levelNumber: 3
            },
            {
              content: '盐田区',

              levelNumber: 3
            },
            {
              content: '龙华区',

              levelNumber: 3
            },
            {
              content: '坪山区',

              levelNumber: 3
            },
            {
              content: '光明区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '珠海市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '香洲区',

              levelNumber: 3
            },
            {
              content: '斗门区',

              levelNumber: 3
            },
            {
              content: '金湾区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '汕头市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '龙湖区',

              levelNumber: 3
            },
            {
              content: '金平区',

              levelNumber: 3
            },
            {
              content: '濠江区',

              levelNumber: 3
            },
            {
              content: '潮阳区',

              levelNumber: 3
            },
            {
              content: '潮南区',

              levelNumber: 3
            },
            {
              content: '澄海区',

              levelNumber: 3
            },
            {
              content: '南澳县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '佛山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '禅城区',

              levelNumber: 3
            },
            {
              content: '南海区',

              levelNumber: 3
            },
            {
              content: '顺德区',

              levelNumber: 3
            },
            {
              content: '三水区',

              levelNumber: 3
            },
            {
              content: '高明区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '江门市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '蓬江区',

              levelNumber: 3
            },
            {
              content: '江海区',

              levelNumber: 3
            },
            {
              content: '新会区',

              levelNumber: 3
            },
            {
              content: '台山市',

              levelNumber: 3
            },
            {
              content: '开平市',

              levelNumber: 3
            },
            {
              content: '鹤山市',

              levelNumber: 3
            },
            {
              content: '恩平市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '湛江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '赤坎区',

              levelNumber: 3
            },
            {
              content: '霞山区',

              levelNumber: 3
            },
            {
              content: '坡头区',

              levelNumber: 3
            },
            {
              content: '麻章区',

              levelNumber: 3
            },
            {
              content: '遂溪县',

              levelNumber: 3
            },
            {
              content: '徐闻县',

              levelNumber: 3
            },
            {
              content: '廉江市',

              levelNumber: 3
            },
            {
              content: '雷州市',

              levelNumber: 3
            },
            {
              content: '吴川市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '茂名市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '茂南区',

              levelNumber: 3
            },
            {
              content: '电白区',

              levelNumber: 3
            },
            {
              content: '高州市',

              levelNumber: 3
            },
            {
              content: '化州市',

              levelNumber: 3
            },
            {
              content: '信宜市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '肇庆市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '端州区',

              levelNumber: 3
            },
            {
              content: '鼎湖区',

              levelNumber: 3
            },
            {
              content: '高要区',

              levelNumber: 3
            },
            {
              content: '广宁县',

              levelNumber: 3
            },
            {
              content: '怀集县',

              levelNumber: 3
            },
            {
              content: '封开县',

              levelNumber: 3
            },
            {
              content: '德庆县',

              levelNumber: 3
            },
            {
              content: '四会市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '惠州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '惠城区',

              levelNumber: 3
            },
            {
              content: '惠阳区',

              levelNumber: 3
            },
            {
              content: '博罗县',

              levelNumber: 3
            },
            {
              content: '惠东县',

              levelNumber: 3
            },
            {
              content: '龙门县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '梅州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '梅江区',

              levelNumber: 3
            },
            {
              content: '梅县区',

              levelNumber: 3
            },
            {
              content: '大埔县',

              levelNumber: 3
            },
            {
              content: '丰顺县',

              levelNumber: 3
            },
            {
              content: '五华县',

              levelNumber: 3
            },
            {
              content: '平远县',

              levelNumber: 3
            },
            {
              content: '蕉岭县',

              levelNumber: 3
            },
            {
              content: '兴宁市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '汕尾市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城区',

              levelNumber: 3
            },
            {
              content: '海丰县',

              levelNumber: 3
            },
            {
              content: '陆河县',

              levelNumber: 3
            },
            {
              content: '陆丰市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '河源市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '源城区',

              levelNumber: 3
            },
            {
              content: '紫金县',

              levelNumber: 3
            },
            {
              content: '龙川县',

              levelNumber: 3
            },
            {
              content: '连平县',

              levelNumber: 3
            },
            {
              content: '和平县',

              levelNumber: 3
            },
            {
              content: '东源县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阳江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '江城区',

              levelNumber: 3
            },
            {
              content: '阳东区',

              levelNumber: 3
            },
            {
              content: '阳西县',

              levelNumber: 3
            },
            {
              content: '阳春市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '清远市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '清城区',

              levelNumber: 3
            },
            {
              content: '清新区',

              levelNumber: 3
            },
            {
              content: '佛冈县',

              levelNumber: 3
            },
            {
              content: '阳山县',

              levelNumber: 3
            },
            {
              content: '连山壮族瑶族自治县',

              levelNumber: 3
            },
            {
              content: '连南瑶族自治县',

              levelNumber: 3
            },
            {
              content: '英德市',

              levelNumber: 3
            },
            {
              content: '连州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '东莞市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '莞城街道',

              levelNumber: 3
            },
            {
              content: '常平镇',

              levelNumber: 3
            },
            {
              content: '望牛墩镇',

              levelNumber: 3
            },
            {
              content: '麻涌镇',

              levelNumber: 3
            },
            {
              content: '松山湖管委会',

              levelNumber: 3
            },
            {
              content: '凤岗镇',

              levelNumber: 3
            },
            {
              content: '东莞生态园',

              levelNumber: 3
            },
            {
              content: '桥头镇',

              levelNumber: 3
            },
            {
              content: '樟木头镇',

              levelNumber: 3
            },
            {
              content: '石龙镇',

              levelNumber: 3
            },
            {
              content: '寮步镇',

              levelNumber: 3
            },
            {
              content: '高埗镇',

              levelNumber: 3
            },
            {
              content: '塘厦镇',

              levelNumber: 3
            },
            {
              content: '厚街镇',

              levelNumber: 3
            },
            {
              content: '谢岗镇',

              levelNumber: 3
            },
            {
              content: '虎门镇',

              levelNumber: 3
            },
            {
              content: '南城街道',

              levelNumber: 3
            },
            {
              content: '虎门港管委会',

              levelNumber: 3
            },
            {
              content: '横沥镇',

              levelNumber: 3
            },
            {
              content: '企石镇',

              levelNumber: 3
            },
            {
              content: '东坑镇',

              levelNumber: 3
            },
            {
              content: '东城街道',

              levelNumber: 3
            },
            {
              content: '石排镇',

              levelNumber: 3
            },
            {
              content: '洪梅镇',

              levelNumber: 3
            },
            {
              content: '道滘镇',

              levelNumber: 3
            },
            {
              content: '沙田镇',

              levelNumber: 3
            },
            {
              content: '大岭山镇',

              levelNumber: 3
            },
            {
              content: '茶山镇',

              levelNumber: 3
            },
            {
              content: '清溪镇',

              levelNumber: 3
            },
            {
              content: '石碣镇',

              levelNumber: 3
            },
            {
              content: '万江街道',

              levelNumber: 3
            },
            {
              content: '中堂镇',

              levelNumber: 3
            },
            {
              content: '黄江镇',

              levelNumber: 3
            },
            {
              content: '长安镇',

              levelNumber: 3
            },
            {
              content: '大朗镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '中山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '三角镇',

              levelNumber: 3
            },
            {
              content: '横栏镇',

              levelNumber: 3
            },
            {
              content: '五桂山街道',

              levelNumber: 3
            },
            {
              content: '小榄镇',

              levelNumber: 3
            },
            {
              content: '中山港街道',

              levelNumber: 3
            },
            {
              content: '神湾镇',

              levelNumber: 3
            },
            {
              content: '南朗街道',

              levelNumber: 3
            },
            {
              content: '古镇镇',

              levelNumber: 3
            },
            {
              content: '民众街道',

              levelNumber: 3
            },
            {
              content: '港口镇',

              levelNumber: 3
            },
            {
              content: '三乡镇',

              levelNumber: 3
            },
            {
              content: '石岐街道',

              levelNumber: 3
            },
            {
              content: '大涌镇',

              levelNumber: 3
            },
            {
              content: '南头镇',

              levelNumber: 3
            },
            {
              content: '东区街道',

              levelNumber: 3
            },
            {
              content: '黄圃镇',

              levelNumber: 3
            },
            {
              content: '阜沙镇',

              levelNumber: 3
            },
            {
              content: '西区街道',

              levelNumber: 3
            },
            {
              content: '板芙镇',

              levelNumber: 3
            },
            {
              content: '沙溪镇',

              levelNumber: 3
            },
            {
              content: '南区街道',

              levelNumber: 3
            },
            {
              content: '东凤镇',

              levelNumber: 3
            },
            {
              content: '坦洲镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '潮州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '湘桥区',

              levelNumber: 3
            },
            {
              content: '潮安区',

              levelNumber: 3
            },
            {
              content: '饶平县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '揭阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '榕城区',

              levelNumber: 3
            },
            {
              content: '揭东区',

              levelNumber: 3
            },
            {
              content: '揭西县',

              levelNumber: 3
            },
            {
              content: '惠来县',

              levelNumber: 3
            },
            {
              content: '普宁市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '云浮市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '云城区',

              levelNumber: 3
            },
            {
              content: '云安区',

              levelNumber: 3
            },
            {
              content: '新兴县',

              levelNumber: 3
            },
            {
              content: '郁南县',

              levelNumber: 3
            },
            {
              content: '罗定市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '广西壮族自治区',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '南宁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '兴宁区',

              levelNumber: 3
            },
            {
              content: '青秀区',

              levelNumber: 3
            },
            {
              content: '江南区',

              levelNumber: 3
            },
            {
              content: '西乡塘区',

              levelNumber: 3
            },
            {
              content: '良庆区',

              levelNumber: 3
            },
            {
              content: '邕宁区',

              levelNumber: 3
            },
            {
              content: '武鸣区',

              levelNumber: 3
            },
            {
              content: '隆安县',

              levelNumber: 3
            },
            {
              content: '马山县',

              levelNumber: 3
            },
            {
              content: '上林县',

              levelNumber: 3
            },
            {
              content: '宾阳县',

              levelNumber: 3
            },
            {
              content: '横州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '柳州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城中区',

              levelNumber: 3
            },
            {
              content: '鱼峰区',

              levelNumber: 3
            },
            {
              content: '柳南区',

              levelNumber: 3
            },
            {
              content: '柳北区',

              levelNumber: 3
            },
            {
              content: '柳江区',

              levelNumber: 3
            },
            {
              content: '柳城县',

              levelNumber: 3
            },
            {
              content: '鹿寨县',

              levelNumber: 3
            },
            {
              content: '融安县',

              levelNumber: 3
            },
            {
              content: '融水苗族自治县',

              levelNumber: 3
            },
            {
              content: '三江侗族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '桂林市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '秀峰区',

              levelNumber: 3
            },
            {
              content: '叠彩区',

              levelNumber: 3
            },
            {
              content: '象山区',

              levelNumber: 3
            },
            {
              content: '七星区',

              levelNumber: 3
            },
            {
              content: '雁山区',

              levelNumber: 3
            },
            {
              content: '临桂区',

              levelNumber: 3
            },
            {
              content: '阳朔县',

              levelNumber: 3
            },
            {
              content: '灵川县',

              levelNumber: 3
            },
            {
              content: '全州县',

              levelNumber: 3
            },
            {
              content: '兴安县',

              levelNumber: 3
            },
            {
              content: '永福县',

              levelNumber: 3
            },
            {
              content: '灌阳县',

              levelNumber: 3
            },
            {
              content: '龙胜各族自治县',

              levelNumber: 3
            },
            {
              content: '资源县',

              levelNumber: 3
            },
            {
              content: '平乐县',

              levelNumber: 3
            },
            {
              content: '恭城瑶族自治县',

              levelNumber: 3
            },
            {
              content: '荔浦市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '梧州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '万秀区',

              levelNumber: 3
            },
            {
              content: '长洲区',

              levelNumber: 3
            },
            {
              content: '龙圩区',

              levelNumber: 3
            },
            {
              content: '苍梧县',

              levelNumber: 3
            },
            {
              content: '藤县',

              levelNumber: 3
            },
            {
              content: '蒙山县',

              levelNumber: 3
            },
            {
              content: '岑溪市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '北海市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海城区',

              levelNumber: 3
            },
            {
              content: '银海区',

              levelNumber: 3
            },
            {
              content: '铁山港区',

              levelNumber: 3
            },
            {
              content: '合浦县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '防城港市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '港口区',

              levelNumber: 3
            },
            {
              content: '防城区',

              levelNumber: 3
            },
            {
              content: '上思县',

              levelNumber: 3
            },
            {
              content: '东兴市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '钦州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '钦南区',

              levelNumber: 3
            },
            {
              content: '钦北区',

              levelNumber: 3
            },
            {
              content: '灵山县',

              levelNumber: 3
            },
            {
              content: '浦北县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '贵港市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '港北区',

              levelNumber: 3
            },
            {
              content: '港南区',

              levelNumber: 3
            },
            {
              content: '覃塘区',

              levelNumber: 3
            },
            {
              content: '平南县',

              levelNumber: 3
            },
            {
              content: '桂平市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '玉林市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '玉州区',

              levelNumber: 3
            },
            {
              content: '福绵区',

              levelNumber: 3
            },
            {
              content: '容县',

              levelNumber: 3
            },
            {
              content: '陆川县',

              levelNumber: 3
            },
            {
              content: '博白县',

              levelNumber: 3
            },
            {
              content: '兴业县',

              levelNumber: 3
            },
            {
              content: '北流市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '百色市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '右江区',

              levelNumber: 3
            },
            {
              content: '田阳区',

              levelNumber: 3
            },
            {
              content: '田东县',

              levelNumber: 3
            },
            {
              content: '德保县',

              levelNumber: 3
            },
            {
              content: '那坡县',

              levelNumber: 3
            },
            {
              content: '凌云县',

              levelNumber: 3
            },
            {
              content: '乐业县',

              levelNumber: 3
            },
            {
              content: '田林县',

              levelNumber: 3
            },
            {
              content: '西林县',

              levelNumber: 3
            },
            {
              content: '隆林各族自治县',

              levelNumber: 3
            },
            {
              content: '靖西市',

              levelNumber: 3
            },
            {
              content: '平果市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '贺州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '八步区',

              levelNumber: 3
            },
            {
              content: '平桂区',

              levelNumber: 3
            },
            {
              content: '昭平县',

              levelNumber: 3
            },
            {
              content: '钟山县',

              levelNumber: 3
            },
            {
              content: '富川瑶族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '河池市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '金城江区',

              levelNumber: 3
            },
            {
              content: '宜州区',

              levelNumber: 3
            },
            {
              content: '南丹县',

              levelNumber: 3
            },
            {
              content: '天峨县',

              levelNumber: 3
            },
            {
              content: '凤山县',

              levelNumber: 3
            },
            {
              content: '东兰县',

              levelNumber: 3
            },
            {
              content: '罗城仫佬族自治县',

              levelNumber: 3
            },
            {
              content: '环江毛南族自治县',

              levelNumber: 3
            },
            {
              content: '巴马瑶族自治县',

              levelNumber: 3
            },
            {
              content: '都安瑶族自治县',

              levelNumber: 3
            },
            {
              content: '大化瑶族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '来宾市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '兴宾区',

              levelNumber: 3
            },
            {
              content: '忻城县',

              levelNumber: 3
            },
            {
              content: '象州县',

              levelNumber: 3
            },
            {
              content: '武宣县',

              levelNumber: 3
            },
            {
              content: '金秀瑶族自治县',

              levelNumber: 3
            },
            {
              content: '合山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '崇左市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '江州区',

              levelNumber: 3
            },
            {
              content: '扶绥县',

              levelNumber: 3
            },
            {
              content: '宁明县',

              levelNumber: 3
            },
            {
              content: '龙州县',

              levelNumber: 3
            },
            {
              content: '大新县',

              levelNumber: 3
            },
            {
              content: '天等县',

              levelNumber: 3
            },
            {
              content: '凭祥市',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '海南省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '海口市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '秀英区',

              levelNumber: 3
            },
            {
              content: '龙华区',

              levelNumber: 3
            },
            {
              content: '琼山区',

              levelNumber: 3
            },
            {
              content: '美兰区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '三亚市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海棠区',

              levelNumber: 3
            },
            {
              content: '吉阳区',

              levelNumber: 3
            },
            {
              content: '天涯区',

              levelNumber: 3
            },
            {
              content: '崖州区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '三沙市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '西沙区',

              levelNumber: 3
            },
            {
              content: '南沙区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '儋州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '光村镇',

              levelNumber: 3
            },
            {
              content: '兰洋镇',

              levelNumber: 3
            },
            {
              content: '海头镇',

              levelNumber: 3
            },
            {
              content: '中和镇',

              levelNumber: 3
            },
            {
              content: '新州镇',

              levelNumber: 3
            },
            {
              content: '木棠镇',

              levelNumber: 3
            },
            {
              content: '王五镇',

              levelNumber: 3
            },
            {
              content: '南丰镇',

              levelNumber: 3
            },
            {
              content: '排浦镇',

              levelNumber: 3
            },
            {
              content: '峨蔓镇',

              levelNumber: 3
            },
            {
              content: '白马井镇',

              levelNumber: 3
            },
            {
              content: '东成镇',

              levelNumber: 3
            },
            {
              content: '大成镇',

              levelNumber: 3
            },
            {
              content: '雅星镇',

              levelNumber: 3
            },
            {
              content: '那大镇',

              levelNumber: 3
            },
            {
              content: '和庆镇',

              levelNumber: 3
            },
            {
              content: '三都镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '五指山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '南圣镇',

              levelNumber: 3
            },
            {
              content: '毛阳镇',

              levelNumber: 3
            },
            {
              content: '水满乡',

              levelNumber: 3
            },
            {
              content: '番阳镇',

              levelNumber: 3
            },
            {
              content: '畅好乡',

              levelNumber: 3
            },
            {
              content: '毛道乡',

              levelNumber: 3
            },
            {
              content: '通什镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '琼海市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '嘉积镇',

              levelNumber: 3
            },
            {
              content: '潭门镇',

              levelNumber: 3
            },
            {
              content: '塔洋镇',

              levelNumber: 3
            },
            {
              content: '博鳌镇',

              levelNumber: 3
            },
            {
              content: '中原镇',

              levelNumber: 3
            },
            {
              content: '石壁镇',

              levelNumber: 3
            },
            {
              content: '长坡镇',

              levelNumber: 3
            },
            {
              content: '大路镇',

              levelNumber: 3
            },
            {
              content: '万泉镇',

              levelNumber: 3
            },
            {
              content: '龙江镇',

              levelNumber: 3
            },
            {
              content: '会山镇',

              levelNumber: 3
            },
            {
              content: '阳江镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '文昌市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '文教镇',

              levelNumber: 3
            },
            {
              content: '会文镇',

              levelNumber: 3
            },
            {
              content: '铺前镇',

              levelNumber: 3
            },
            {
              content: '冯坡镇',

              levelNumber: 3
            },
            {
              content: '东郊镇',

              levelNumber: 3
            },
            {
              content: '龙楼镇',

              levelNumber: 3
            },
            {
              content: '翁田镇',

              levelNumber: 3
            },
            {
              content: '昌洒镇',

              levelNumber: 3
            },
            {
              content: '公坡镇',

              levelNumber: 3
            },
            {
              content: '潭牛镇',

              levelNumber: 3
            },
            {
              content: '文城镇',

              levelNumber: 3
            },
            {
              content: '锦山镇',

              levelNumber: 3
            },
            {
              content: '抱罗镇',

              levelNumber: 3
            },
            {
              content: '东阁镇',

              levelNumber: 3
            },
            {
              content: '东路镇',

              levelNumber: 3
            },
            {
              content: '蓬莱镇',

              levelNumber: 3
            },
            {
              content: '重兴镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '万宁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '后安镇',

              levelNumber: 3
            },
            {
              content: '礼纪镇',

              levelNumber: 3
            },
            {
              content: '万城镇',

              levelNumber: 3
            },
            {
              content: '大茂镇',

              levelNumber: 3
            },
            {
              content: '和乐镇',

              levelNumber: 3
            },
            {
              content: '山根镇',

              levelNumber: 3
            },
            {
              content: '东澳镇',

              levelNumber: 3
            },
            {
              content: '南桥镇',

              levelNumber: 3
            },
            {
              content: '龙滚镇',

              levelNumber: 3
            },
            {
              content: '长丰镇',

              levelNumber: 3
            },
            {
              content: '三更罗镇',

              levelNumber: 3
            },
            {
              content: '北大镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '东方市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '江边乡',

              levelNumber: 3
            },
            {
              content: '天安乡',

              levelNumber: 3
            },
            {
              content: '三家镇',

              levelNumber: 3
            },
            {
              content: '四更镇',

              levelNumber: 3
            },
            {
              content: '东河镇',

              levelNumber: 3
            },
            {
              content: '八所镇',

              levelNumber: 3
            },
            {
              content: '感城镇',

              levelNumber: 3
            },
            {
              content: '新龙镇',

              levelNumber: 3
            },
            {
              content: '板桥镇',

              levelNumber: 3
            },
            {
              content: '大田镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '定安县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '岭口镇',

              levelNumber: 3
            },
            {
              content: '新竹镇',

              levelNumber: 3
            },
            {
              content: '龙门镇',

              levelNumber: 3
            },
            {
              content: '富文镇',

              levelNumber: 3
            },
            {
              content: '翰林镇',

              levelNumber: 3
            },
            {
              content: '定城镇',

              levelNumber: 3
            },
            {
              content: '龙河镇',

              levelNumber: 3
            },
            {
              content: '雷鸣镇',

              levelNumber: 3
            },
            {
              content: '黄竹镇',

              levelNumber: 3
            },
            {
              content: '龙湖镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '屯昌县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '乌坡镇',

              levelNumber: 3
            },
            {
              content: '西昌镇',

              levelNumber: 3
            },
            {
              content: '枫木镇',

              levelNumber: 3
            },
            {
              content: '南坤镇',

              levelNumber: 3
            },
            {
              content: '南吕镇',

              levelNumber: 3
            },
            {
              content: '屯城镇',

              levelNumber: 3
            },
            {
              content: '坡心镇',

              levelNumber: 3
            },
            {
              content: '新兴镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '澄迈县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '金江镇',

              levelNumber: 3
            },
            {
              content: '老城镇',

              levelNumber: 3
            },
            {
              content: '永发镇',

              levelNumber: 3
            },
            {
              content: '桥头镇',

              levelNumber: 3
            },
            {
              content: '大丰镇',

              levelNumber: 3
            },
            {
              content: '瑞溪镇',

              levelNumber: 3
            },
            {
              content: '福山镇',

              levelNumber: 3
            },
            {
              content: '仁兴镇',

              levelNumber: 3
            },
            {
              content: '加乐镇',

              levelNumber: 3
            },
            {
              content: '文儒镇',

              levelNumber: 3
            },
            {
              content: '中兴镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '临高县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '博厚镇',

              levelNumber: 3
            },
            {
              content: '南宝镇',

              levelNumber: 3
            },
            {
              content: '和舍镇',

              levelNumber: 3
            },
            {
              content: '调楼镇',

              levelNumber: 3
            },
            {
              content: '波莲镇',

              levelNumber: 3
            },
            {
              content: '加来镇',

              levelNumber: 3
            },
            {
              content: '东英镇',

              levelNumber: 3
            },
            {
              content: '新盈镇',

              levelNumber: 3
            },
            {
              content: '临城镇',

              levelNumber: 3
            },
            {
              content: '多文镇',

              levelNumber: 3
            },
            {
              content: '皇桐镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '白沙黎族自治县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '南开乡',

              levelNumber: 3
            },
            {
              content: '阜龙乡',

              levelNumber: 3
            },
            {
              content: '邦溪镇',

              levelNumber: 3
            },
            {
              content: '金波乡',

              levelNumber: 3
            },
            {
              content: '牙叉镇',

              levelNumber: 3
            },
            {
              content: '打安镇',

              levelNumber: 3
            },
            {
              content: '青松乡',

              levelNumber: 3
            },
            {
              content: '荣邦乡',

              levelNumber: 3
            },
            {
              content: '细水乡',

              levelNumber: 3
            },
            {
              content: '元门乡',

              levelNumber: 3
            },
            {
              content: '七坊镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '昌江黎族自治县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海尾镇',

              levelNumber: 3
            },
            {
              content: '叉河镇',

              levelNumber: 3
            },
            {
              content: '石碌镇',

              levelNumber: 3
            },
            {
              content: '乌烈镇',

              levelNumber: 3
            },
            {
              content: '昌化镇',

              levelNumber: 3
            },
            {
              content: '王下乡',

              levelNumber: 3
            },
            {
              content: '七叉镇',

              levelNumber: 3
            },
            {
              content: '十月田镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '乐东黎族自治县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '利国镇',

              levelNumber: 3
            },
            {
              content: '佛罗镇',

              levelNumber: 3
            },
            {
              content: '大安镇',

              levelNumber: 3
            },
            {
              content: '黄流镇',

              levelNumber: 3
            },
            {
              content: '志仲镇',

              levelNumber: 3
            },
            {
              content: '莺歌海镇',

              levelNumber: 3
            },
            {
              content: '抱由镇',

              levelNumber: 3
            },
            {
              content: '尖峰镇',

              levelNumber: 3
            },
            {
              content: '九所镇',

              levelNumber: 3
            },
            {
              content: '万冲镇',

              levelNumber: 3
            },
            {
              content: '千家镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '陵水黎族自治县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '椰林镇',

              levelNumber: 3
            },
            {
              content: '新村镇',

              levelNumber: 3
            },
            {
              content: '黎安镇',

              levelNumber: 3
            },
            {
              content: '文罗镇',

              levelNumber: 3
            },
            {
              content: '提蒙乡',

              levelNumber: 3
            },
            {
              content: '群英乡',

              levelNumber: 3
            },
            {
              content: '三才镇',

              levelNumber: 3
            },
            {
              content: '隆广镇',

              levelNumber: 3
            },
            {
              content: '英州镇',

              levelNumber: 3
            },
            {
              content: '光坡镇',

              levelNumber: 3
            },
            {
              content: '本号镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '保亭黎族苗族自治县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '南林乡',

              levelNumber: 3
            },
            {
              content: '毛感乡',

              levelNumber: 3
            },
            {
              content: '什玲镇',

              levelNumber: 3
            },
            {
              content: '新政镇',

              levelNumber: 3
            },
            {
              content: '保城镇',

              levelNumber: 3
            },
            {
              content: '加茂镇',

              levelNumber: 3
            },
            {
              content: '六弓乡',

              levelNumber: 3
            },
            {
              content: '三道镇',

              levelNumber: 3
            },
            {
              content: '响水镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '琼中黎族苗族自治县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '上安乡',

              levelNumber: 3
            },
            {
              content: '什运乡',

              levelNumber: 3
            },
            {
              content: '湾岭镇',

              levelNumber: 3
            },
            {
              content: '红毛镇',

              levelNumber: 3
            },
            {
              content: '黎母山镇',

              levelNumber: 3
            },
            {
              content: '营根镇',

              levelNumber: 3
            },
            {
              content: '吊罗山乡',

              levelNumber: 3
            },
            {
              content: '中平镇',

              levelNumber: 3
            },
            {
              content: '和平镇',

              levelNumber: 3
            },
            {
              content: '长征镇',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '重庆市',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '重庆城区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '万州区',

              levelNumber: 3
            },
            {
              content: '涪陵区',

              levelNumber: 3
            },
            {
              content: '渝中区',

              levelNumber: 3
            },
            {
              content: '大渡口区',

              levelNumber: 3
            },
            {
              content: '江北区',

              levelNumber: 3
            },
            {
              content: '沙坪坝区',

              levelNumber: 3
            },
            {
              content: '九龙坡区',

              levelNumber: 3
            },
            {
              content: '南岸区',

              levelNumber: 3
            },
            {
              content: '北碚区',

              levelNumber: 3
            },
            {
              content: '綦江区',

              levelNumber: 3
            },
            {
              content: '大足区',

              levelNumber: 3
            },
            {
              content: '渝北区',

              levelNumber: 3
            },
            {
              content: '巴南区',

              levelNumber: 3
            },
            {
              content: '黔江区',

              levelNumber: 3
            },
            {
              content: '长寿区',

              levelNumber: 3
            },
            {
              content: '江津区',

              levelNumber: 3
            },
            {
              content: '合川区',

              levelNumber: 3
            },
            {
              content: '永川区',

              levelNumber: 3
            },
            {
              content: '南川区',

              levelNumber: 3
            },
            {
              content: '璧山区',

              levelNumber: 3
            },
            {
              content: '铜梁区',

              levelNumber: 3
            },
            {
              content: '潼南区',

              levelNumber: 3
            },
            {
              content: '荣昌区',

              levelNumber: 3
            },
            {
              content: '开州区',

              levelNumber: 3
            },
            {
              content: '梁平区',

              levelNumber: 3
            },
            {
              content: '武隆区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '重庆郊县',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城口县',

              levelNumber: 3
            },
            {
              content: '丰都县',

              levelNumber: 3
            },
            {
              content: '垫江县',

              levelNumber: 3
            },
            {
              content: '忠县',

              levelNumber: 3
            },
            {
              content: '云阳县',

              levelNumber: 3
            },
            {
              content: '奉节县',

              levelNumber: 3
            },
            {
              content: '巫山县',

              levelNumber: 3
            },
            {
              content: '巫溪县',

              levelNumber: 3
            },
            {
              content: '石柱土家族自治县',

              levelNumber: 3
            },
            {
              content: '秀山土家族苗族自治县',

              levelNumber: 3
            },
            {
              content: '酉阳土家族苗族自治县',

              levelNumber: 3
            },
            {
              content: '彭水苗族土家族自治县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '四川省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '成都市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '锦江区',

              levelNumber: 3
            },
            {
              content: '青羊区',

              levelNumber: 3
            },
            {
              content: '金牛区',

              levelNumber: 3
            },
            {
              content: '武侯区',

              levelNumber: 3
            },
            {
              content: '成华区',

              levelNumber: 3
            },
            {
              content: '龙泉驿区',

              levelNumber: 3
            },
            {
              content: '青白江区',

              levelNumber: 3
            },
            {
              content: '新都区',

              levelNumber: 3
            },
            {
              content: '温江区',

              levelNumber: 3
            },
            {
              content: '双流区',

              levelNumber: 3
            },
            {
              content: '郫都区',

              levelNumber: 3
            },
            {
              content: '新津区',

              levelNumber: 3
            },
            {
              content: '金堂县',

              levelNumber: 3
            },
            {
              content: '大邑县',

              levelNumber: 3
            },
            {
              content: '蒲江县',

              levelNumber: 3
            },
            {
              content: '都江堰市',

              levelNumber: 3
            },
            {
              content: '彭州市',

              levelNumber: 3
            },
            {
              content: '邛崃市',

              levelNumber: 3
            },
            {
              content: '崇州市',

              levelNumber: 3
            },
            {
              content: '简阳市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '自贡市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '自流井区',

              levelNumber: 3
            },
            {
              content: '贡井区',

              levelNumber: 3
            },
            {
              content: '大安区',

              levelNumber: 3
            },
            {
              content: '沿滩区',

              levelNumber: 3
            },
            {
              content: '荣县',

              levelNumber: 3
            },
            {
              content: '富顺县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '攀枝花市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东区',

              levelNumber: 3
            },
            {
              content: '西区',

              levelNumber: 3
            },
            {
              content: '仁和区',

              levelNumber: 3
            },
            {
              content: '米易县',

              levelNumber: 3
            },
            {
              content: '盐边县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '泸州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '江阳区',

              levelNumber: 3
            },
            {
              content: '纳溪区',

              levelNumber: 3
            },
            {
              content: '龙马潭区',

              levelNumber: 3
            },
            {
              content: '泸县',

              levelNumber: 3
            },
            {
              content: '合江县',

              levelNumber: 3
            },
            {
              content: '叙永县',

              levelNumber: 3
            },
            {
              content: '古蔺县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '德阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '旌阳区',

              levelNumber: 3
            },
            {
              content: '罗江区',

              levelNumber: 3
            },
            {
              content: '中江县',

              levelNumber: 3
            },
            {
              content: '广汉市',

              levelNumber: 3
            },
            {
              content: '什邡市',

              levelNumber: 3
            },
            {
              content: '绵竹市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '绵阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '涪城区',

              levelNumber: 3
            },
            {
              content: '游仙区',

              levelNumber: 3
            },
            {
              content: '安州区',

              levelNumber: 3
            },
            {
              content: '三台县',

              levelNumber: 3
            },
            {
              content: '盐亭县',

              levelNumber: 3
            },
            {
              content: '梓潼县',

              levelNumber: 3
            },
            {
              content: '北川羌族自治县',

              levelNumber: 3
            },
            {
              content: '平武县',

              levelNumber: 3
            },
            {
              content: '江油市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '广元市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '利州区',

              levelNumber: 3
            },
            {
              content: '昭化区',

              levelNumber: 3
            },
            {
              content: '朝天区',

              levelNumber: 3
            },
            {
              content: '旺苍县',

              levelNumber: 3
            },
            {
              content: '青川县',

              levelNumber: 3
            },
            {
              content: '剑阁县',

              levelNumber: 3
            },
            {
              content: '苍溪县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '遂宁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '船山区',

              levelNumber: 3
            },
            {
              content: '安居区',

              levelNumber: 3
            },
            {
              content: '蓬溪县',

              levelNumber: 3
            },
            {
              content: '大英县',

              levelNumber: 3
            },
            {
              content: '射洪市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '内江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '市中区',

              levelNumber: 3
            },
            {
              content: '东兴区',

              levelNumber: 3
            },
            {
              content: '威远县',

              levelNumber: 3
            },
            {
              content: '资中县',

              levelNumber: 3
            },
            {
              content: '隆昌市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '乐山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '市中区',

              levelNumber: 3
            },
            {
              content: '沙湾区',

              levelNumber: 3
            },
            {
              content: '五通桥区',

              levelNumber: 3
            },
            {
              content: '金口河区',

              levelNumber: 3
            },
            {
              content: '犍为县',

              levelNumber: 3
            },
            {
              content: '井研县',

              levelNumber: 3
            },
            {
              content: '夹江县',

              levelNumber: 3
            },
            {
              content: '沐川县',

              levelNumber: 3
            },
            {
              content: '峨边彝族自治县',

              levelNumber: 3
            },
            {
              content: '马边彝族自治县',

              levelNumber: 3
            },
            {
              content: '峨眉山市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '南充市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '顺庆区',

              levelNumber: 3
            },
            {
              content: '高坪区',

              levelNumber: 3
            },
            {
              content: '嘉陵区',

              levelNumber: 3
            },
            {
              content: '南部县',

              levelNumber: 3
            },
            {
              content: '营山县',

              levelNumber: 3
            },
            {
              content: '蓬安县',

              levelNumber: 3
            },
            {
              content: '仪陇县',

              levelNumber: 3
            },
            {
              content: '西充县',

              levelNumber: 3
            },
            {
              content: '阆中市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '眉山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '东坡区',

              levelNumber: 3
            },
            {
              content: '彭山区',

              levelNumber: 3
            },
            {
              content: '仁寿县',

              levelNumber: 3
            },
            {
              content: '洪雅县',

              levelNumber: 3
            },
            {
              content: '丹棱县',

              levelNumber: 3
            },
            {
              content: '青神县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宜宾市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '翠屏区',

              levelNumber: 3
            },
            {
              content: '南溪区',

              levelNumber: 3
            },
            {
              content: '叙州区',

              levelNumber: 3
            },
            {
              content: '江安县',

              levelNumber: 3
            },
            {
              content: '长宁县',

              levelNumber: 3
            },
            {
              content: '高县',

              levelNumber: 3
            },
            {
              content: '珙县',

              levelNumber: 3
            },
            {
              content: '筠连县',

              levelNumber: 3
            },
            {
              content: '兴文县',

              levelNumber: 3
            },
            {
              content: '屏山县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '广安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '广安区',

              levelNumber: 3
            },
            {
              content: '前锋区',

              levelNumber: 3
            },
            {
              content: '岳池县',

              levelNumber: 3
            },
            {
              content: '武胜县',

              levelNumber: 3
            },
            {
              content: '邻水县',

              levelNumber: 3
            },
            {
              content: '华蓥市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '达州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '通川区',

              levelNumber: 3
            },
            {
              content: '达川区',

              levelNumber: 3
            },
            {
              content: '宣汉县',

              levelNumber: 3
            },
            {
              content: '开江县',

              levelNumber: 3
            },
            {
              content: '大竹县',

              levelNumber: 3
            },
            {
              content: '渠县',

              levelNumber: 3
            },
            {
              content: '万源市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '雅安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '雨城区',

              levelNumber: 3
            },
            {
              content: '名山区',

              levelNumber: 3
            },
            {
              content: '荥经县',

              levelNumber: 3
            },
            {
              content: '汉源县',

              levelNumber: 3
            },
            {
              content: '石棉县',

              levelNumber: 3
            },
            {
              content: '天全县',

              levelNumber: 3
            },
            {
              content: '芦山县',

              levelNumber: 3
            },
            {
              content: '宝兴县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '巴中市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '巴州区',

              levelNumber: 3
            },
            {
              content: '恩阳区',

              levelNumber: 3
            },
            {
              content: '通江县',

              levelNumber: 3
            },
            {
              content: '南江县',

              levelNumber: 3
            },
            {
              content: '平昌县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '资阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '雁江区',

              levelNumber: 3
            },
            {
              content: '安岳县',

              levelNumber: 3
            },
            {
              content: '乐至县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阿坝藏族羌族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '马尔康市',

              levelNumber: 3
            },
            {
              content: '汶川县',

              levelNumber: 3
            },
            {
              content: '理县',

              levelNumber: 3
            },
            {
              content: '茂县',

              levelNumber: 3
            },
            {
              content: '松潘县',

              levelNumber: 3
            },
            {
              content: '九寨沟县',

              levelNumber: 3
            },
            {
              content: '金川县',

              levelNumber: 3
            },
            {
              content: '小金县',

              levelNumber: 3
            },
            {
              content: '黑水县',

              levelNumber: 3
            },
            {
              content: '壤塘县',

              levelNumber: 3
            },
            {
              content: '阿坝县',

              levelNumber: 3
            },
            {
              content: '若尔盖县',

              levelNumber: 3
            },
            {
              content: '红原县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '甘孜藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '康定市',

              levelNumber: 3
            },
            {
              content: '泸定县',

              levelNumber: 3
            },
            {
              content: '丹巴县',

              levelNumber: 3
            },
            {
              content: '九龙县',

              levelNumber: 3
            },
            {
              content: '雅江县',

              levelNumber: 3
            },
            {
              content: '道孚县',

              levelNumber: 3
            },
            {
              content: '炉霍县',

              levelNumber: 3
            },
            {
              content: '甘孜县',

              levelNumber: 3
            },
            {
              content: '新龙县',

              levelNumber: 3
            },
            {
              content: '德格县',

              levelNumber: 3
            },
            {
              content: '白玉县',

              levelNumber: 3
            },
            {
              content: '石渠县',

              levelNumber: 3
            },
            {
              content: '色达县',

              levelNumber: 3
            },
            {
              content: '理塘县',

              levelNumber: 3
            },
            {
              content: '巴塘县',

              levelNumber: 3
            },
            {
              content: '乡城县',

              levelNumber: 3
            },
            {
              content: '稻城县',

              levelNumber: 3
            },
            {
              content: '得荣县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '凉山彝族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '西昌市',

              levelNumber: 3
            },
            {
              content: '木里藏族自治县',

              levelNumber: 3
            },
            {
              content: '盐源县',

              levelNumber: 3
            },
            {
              content: '德昌县',

              levelNumber: 3
            },
            {
              content: '会理市',

              levelNumber: 3
            },
            {
              content: '会东县',

              levelNumber: 3
            },
            {
              content: '宁南县',

              levelNumber: 3
            },
            {
              content: '普格县',

              levelNumber: 3
            },
            {
              content: '布拖县',

              levelNumber: 3
            },
            {
              content: '金阳县',

              levelNumber: 3
            },
            {
              content: '昭觉县',

              levelNumber: 3
            },
            {
              content: '喜德县',

              levelNumber: 3
            },
            {
              content: '冕宁县',

              levelNumber: 3
            },
            {
              content: '越西县',

              levelNumber: 3
            },
            {
              content: '甘洛县',

              levelNumber: 3
            },
            {
              content: '美姑县',

              levelNumber: 3
            },
            {
              content: '雷波县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '贵州省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '贵阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '南明区',

              levelNumber: 3
            },
            {
              content: '云岩区',

              levelNumber: 3
            },
            {
              content: '花溪区',

              levelNumber: 3
            },
            {
              content: '乌当区',

              levelNumber: 3
            },
            {
              content: '白云区',

              levelNumber: 3
            },
            {
              content: '观山湖区',

              levelNumber: 3
            },
            {
              content: '开阳县',

              levelNumber: 3
            },
            {
              content: '息烽县',

              levelNumber: 3
            },
            {
              content: '修文县',

              levelNumber: 3
            },
            {
              content: '清镇市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '六盘水市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '钟山区',

              levelNumber: 3
            },
            {
              content: '六枝特区',

              levelNumber: 3
            },
            {
              content: '水城区',

              levelNumber: 3
            },
            {
              content: '盘州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '遵义市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '红花岗区',

              levelNumber: 3
            },
            {
              content: '汇川区',

              levelNumber: 3
            },
            {
              content: '播州区',

              levelNumber: 3
            },
            {
              content: '桐梓县',

              levelNumber: 3
            },
            {
              content: '绥阳县',

              levelNumber: 3
            },
            {
              content: '正安县',

              levelNumber: 3
            },
            {
              content: '道真仡佬族苗族自治县',

              levelNumber: 3
            },
            {
              content: '务川仡佬族苗族自治县',

              levelNumber: 3
            },
            {
              content: '凤冈县',

              levelNumber: 3
            },
            {
              content: '湄潭县',

              levelNumber: 3
            },
            {
              content: '余庆县',

              levelNumber: 3
            },
            {
              content: '习水县',

              levelNumber: 3
            },
            {
              content: '赤水市',

              levelNumber: 3
            },
            {
              content: '仁怀市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '安顺市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '西秀区',

              levelNumber: 3
            },
            {
              content: '平坝区',

              levelNumber: 3
            },
            {
              content: '普定县',

              levelNumber: 3
            },
            {
              content: '镇宁布依族苗族自治县',

              levelNumber: 3
            },
            {
              content: '关岭布依族苗族自治县',

              levelNumber: 3
            },
            {
              content: '紫云苗族布依族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '毕节市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '七星关区',

              levelNumber: 3
            },
            {
              content: '大方县',

              levelNumber: 3
            },
            {
              content: '金沙县',

              levelNumber: 3
            },
            {
              content: '织金县',

              levelNumber: 3
            },
            {
              content: '纳雍县',

              levelNumber: 3
            },
            {
              content: '威宁彝族回族苗族自治县',

              levelNumber: 3
            },
            {
              content: '赫章县',

              levelNumber: 3
            },
            {
              content: '黔西市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '铜仁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '碧江区',

              levelNumber: 3
            },
            {
              content: '万山区',

              levelNumber: 3
            },
            {
              content: '江口县',

              levelNumber: 3
            },
            {
              content: '玉屏侗族自治县',

              levelNumber: 3
            },
            {
              content: '石阡县',

              levelNumber: 3
            },
            {
              content: '思南县',

              levelNumber: 3
            },
            {
              content: '印江土家族苗族自治县',

              levelNumber: 3
            },
            {
              content: '德江县',

              levelNumber: 3
            },
            {
              content: '沿河土家族自治县',

              levelNumber: 3
            },
            {
              content: '松桃苗族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黔西南布依族苗族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '兴义市',

              levelNumber: 3
            },
            {
              content: '兴仁市',

              levelNumber: 3
            },
            {
              content: '普安县',

              levelNumber: 3
            },
            {
              content: '晴隆县',

              levelNumber: 3
            },
            {
              content: '贞丰县',

              levelNumber: 3
            },
            {
              content: '望谟县',

              levelNumber: 3
            },
            {
              content: '册亨县',

              levelNumber: 3
            },
            {
              content: '安龙县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黔东南苗族侗族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '凯里市',

              levelNumber: 3
            },
            {
              content: '黄平县',

              levelNumber: 3
            },
            {
              content: '施秉县',

              levelNumber: 3
            },
            {
              content: '三穗县',

              levelNumber: 3
            },
            {
              content: '镇远县',

              levelNumber: 3
            },
            {
              content: '岑巩县',

              levelNumber: 3
            },
            {
              content: '天柱县',

              levelNumber: 3
            },
            {
              content: '锦屏县',

              levelNumber: 3
            },
            {
              content: '剑河县',

              levelNumber: 3
            },
            {
              content: '台江县',

              levelNumber: 3
            },
            {
              content: '黎平县',

              levelNumber: 3
            },
            {
              content: '榕江县',

              levelNumber: 3
            },
            {
              content: '从江县',

              levelNumber: 3
            },
            {
              content: '雷山县',

              levelNumber: 3
            },
            {
              content: '麻江县',

              levelNumber: 3
            },
            {
              content: '丹寨县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黔南布依族苗族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '都匀市',

              levelNumber: 3
            },
            {
              content: '福泉市',

              levelNumber: 3
            },
            {
              content: '荔波县',

              levelNumber: 3
            },
            {
              content: '贵定县',

              levelNumber: 3
            },
            {
              content: '瓮安县',

              levelNumber: 3
            },
            {
              content: '独山县',

              levelNumber: 3
            },
            {
              content: '平塘县',

              levelNumber: 3
            },
            {
              content: '罗甸县',

              levelNumber: 3
            },
            {
              content: '长顺县',

              levelNumber: 3
            },
            {
              content: '龙里县',

              levelNumber: 3
            },
            {
              content: '惠水县',

              levelNumber: 3
            },
            {
              content: '三都水族自治县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '云南省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '昆明市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '五华区',

              levelNumber: 3
            },
            {
              content: '盘龙区',

              levelNumber: 3
            },
            {
              content: '官渡区',

              levelNumber: 3
            },
            {
              content: '西山区',

              levelNumber: 3
            },
            {
              content: '东川区',

              levelNumber: 3
            },
            {
              content: '呈贡区',

              levelNumber: 3
            },
            {
              content: '晋宁区',

              levelNumber: 3
            },
            {
              content: '富民县',

              levelNumber: 3
            },
            {
              content: '宜良县',

              levelNumber: 3
            },
            {
              content: '石林彝族自治县',

              levelNumber: 3
            },
            {
              content: '嵩明县',

              levelNumber: 3
            },
            {
              content: '禄劝彝族苗族自治县',

              levelNumber: 3
            },
            {
              content: '寻甸回族彝族自治县',

              levelNumber: 3
            },
            {
              content: '安宁市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '曲靖市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '麒麟区',

              levelNumber: 3
            },
            {
              content: '沾益区',

              levelNumber: 3
            },
            {
              content: '马龙区',

              levelNumber: 3
            },
            {
              content: '陆良县',

              levelNumber: 3
            },
            {
              content: '师宗县',

              levelNumber: 3
            },
            {
              content: '罗平县',

              levelNumber: 3
            },
            {
              content: '富源县',

              levelNumber: 3
            },
            {
              content: '会泽县',

              levelNumber: 3
            },
            {
              content: '宣威市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '玉溪市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '红塔区',

              levelNumber: 3
            },
            {
              content: '江川区',

              levelNumber: 3
            },
            {
              content: '通海县',

              levelNumber: 3
            },
            {
              content: '华宁县',

              levelNumber: 3
            },
            {
              content: '易门县',

              levelNumber: 3
            },
            {
              content: '峨山彝族自治县',

              levelNumber: 3
            },
            {
              content: '新平彝族傣族自治县',

              levelNumber: 3
            },
            {
              content: '元江哈尼族彝族傣族自治县',

              levelNumber: 3
            },
            {
              content: '澄江市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '保山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '隆阳区',

              levelNumber: 3
            },
            {
              content: '施甸县',

              levelNumber: 3
            },
            {
              content: '龙陵县',

              levelNumber: 3
            },
            {
              content: '昌宁县',

              levelNumber: 3
            },
            {
              content: '腾冲市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '昭通市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '昭阳区',

              levelNumber: 3
            },
            {
              content: '鲁甸县',

              levelNumber: 3
            },
            {
              content: '巧家县',

              levelNumber: 3
            },
            {
              content: '盐津县',

              levelNumber: 3
            },
            {
              content: '大关县',

              levelNumber: 3
            },
            {
              content: '永善县',

              levelNumber: 3
            },
            {
              content: '绥江县',

              levelNumber: 3
            },
            {
              content: '镇雄县',

              levelNumber: 3
            },
            {
              content: '彝良县',

              levelNumber: 3
            },
            {
              content: '威信县',

              levelNumber: 3
            },
            {
              content: '水富市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '丽江市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '古城区',

              levelNumber: 3
            },
            {
              content: '玉龙纳西族自治县',

              levelNumber: 3
            },
            {
              content: '永胜县',

              levelNumber: 3
            },
            {
              content: '华坪县',

              levelNumber: 3
            },
            {
              content: '宁蒗彝族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '普洱市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '思茅区',

              levelNumber: 3
            },
            {
              content: '宁洱哈尼族彝族自治县',

              levelNumber: 3
            },
            {
              content: '墨江哈尼族自治县',

              levelNumber: 3
            },
            {
              content: '景东彝族自治县',

              levelNumber: 3
            },
            {
              content: '景谷傣族彝族自治县',

              levelNumber: 3
            },
            {
              content: '镇沅彝族哈尼族拉祜族自治县',

              levelNumber: 3
            },
            {
              content: '江城哈尼族彝族自治县',

              levelNumber: 3
            },
            {
              content: '孟连傣族拉祜族佤族自治县',

              levelNumber: 3
            },
            {
              content: '澜沧拉祜族自治县',

              levelNumber: 3
            },
            {
              content: '西盟佤族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '临沧市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '临翔区',

              levelNumber: 3
            },
            {
              content: '凤庆县',

              levelNumber: 3
            },
            {
              content: '云县',

              levelNumber: 3
            },
            {
              content: '永德县',

              levelNumber: 3
            },
            {
              content: '镇康县',

              levelNumber: 3
            },
            {
              content: '双江拉祜族佤族布朗族傣族自治县',

              levelNumber: 3
            },
            {
              content: '耿马傣族佤族自治县',

              levelNumber: 3
            },
            {
              content: '沧源佤族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '楚雄彝族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '楚雄市',

              levelNumber: 3
            },
            {
              content: '双柏县',

              levelNumber: 3
            },
            {
              content: '牟定县',

              levelNumber: 3
            },
            {
              content: '南华县',

              levelNumber: 3
            },
            {
              content: '姚安县',

              levelNumber: 3
            },
            {
              content: '大姚县',

              levelNumber: 3
            },
            {
              content: '永仁县',

              levelNumber: 3
            },
            {
              content: '元谋县',

              levelNumber: 3
            },
            {
              content: '武定县',

              levelNumber: 3
            },
            {
              content: '禄丰市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '红河哈尼族彝族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '个旧市',

              levelNumber: 3
            },
            {
              content: '开远市',

              levelNumber: 3
            },
            {
              content: '蒙自市',

              levelNumber: 3
            },
            {
              content: '弥勒市',

              levelNumber: 3
            },
            {
              content: '屏边苗族自治县',

              levelNumber: 3
            },
            {
              content: '建水县',

              levelNumber: 3
            },
            {
              content: '石屏县',

              levelNumber: 3
            },
            {
              content: '泸西县',

              levelNumber: 3
            },
            {
              content: '元阳县',

              levelNumber: 3
            },
            {
              content: '红河县',

              levelNumber: 3
            },
            {
              content: '金平苗族瑶族傣族自治县',

              levelNumber: 3
            },
            {
              content: '绿春县',

              levelNumber: 3
            },
            {
              content: '河口瑶族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '文山壮族苗族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '文山市',

              levelNumber: 3
            },
            {
              content: '砚山县',

              levelNumber: 3
            },
            {
              content: '西畴县',

              levelNumber: 3
            },
            {
              content: '麻栗坡县',

              levelNumber: 3
            },
            {
              content: '马关县',

              levelNumber: 3
            },
            {
              content: '丘北县',

              levelNumber: 3
            },
            {
              content: '广南县',

              levelNumber: 3
            },
            {
              content: '富宁县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '西双版纳傣族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '景洪市',

              levelNumber: 3
            },
            {
              content: '勐海县',

              levelNumber: 3
            },
            {
              content: '勐腊县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '大理白族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '大理市',

              levelNumber: 3
            },
            {
              content: '漾濞彝族自治县',

              levelNumber: 3
            },
            {
              content: '祥云县',

              levelNumber: 3
            },
            {
              content: '宾川县',

              levelNumber: 3
            },
            {
              content: '弥渡县',

              levelNumber: 3
            },
            {
              content: '南涧彝族自治县',

              levelNumber: 3
            },
            {
              content: '巍山彝族回族自治县',

              levelNumber: 3
            },
            {
              content: '永平县',

              levelNumber: 3
            },
            {
              content: '云龙县',

              levelNumber: 3
            },
            {
              content: '洱源县',

              levelNumber: 3
            },
            {
              content: '剑川县',

              levelNumber: 3
            },
            {
              content: '鹤庆县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '德宏傣族景颇族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '瑞丽市',

              levelNumber: 3
            },
            {
              content: '芒市',

              levelNumber: 3
            },
            {
              content: '梁河县',

              levelNumber: 3
            },
            {
              content: '盈江县',

              levelNumber: 3
            },
            {
              content: '陇川县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '怒江傈僳族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '泸水市',

              levelNumber: 3
            },
            {
              content: '福贡县',

              levelNumber: 3
            },
            {
              content: '贡山独龙族怒族自治县',

              levelNumber: 3
            },
            {
              content: '兰坪白族普米族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '迪庆藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '香格里拉市',

              levelNumber: 3
            },
            {
              content: '德钦县',

              levelNumber: 3
            },
            {
              content: '维西傈僳族自治县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '西藏自治区',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '拉萨市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城关区',

              levelNumber: 3
            },
            {
              content: '堆龙德庆区',

              levelNumber: 3
            },
            {
              content: '达孜区',

              levelNumber: 3
            },
            {
              content: '林周县',

              levelNumber: 3
            },
            {
              content: '当雄县',

              levelNumber: 3
            },
            {
              content: '尼木县',

              levelNumber: 3
            },
            {
              content: '曲水县',

              levelNumber: 3
            },
            {
              content: '墨竹工卡县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '日喀则市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '桑珠孜区',

              levelNumber: 3
            },
            {
              content: '南木林县',

              levelNumber: 3
            },
            {
              content: '江孜县',

              levelNumber: 3
            },
            {
              content: '定日县',

              levelNumber: 3
            },
            {
              content: '萨迦县',

              levelNumber: 3
            },
            {
              content: '拉孜县',

              levelNumber: 3
            },
            {
              content: '昂仁县',

              levelNumber: 3
            },
            {
              content: '谢通门县',

              levelNumber: 3
            },
            {
              content: '白朗县',

              levelNumber: 3
            },
            {
              content: '仁布县',

              levelNumber: 3
            },
            {
              content: '康马县',

              levelNumber: 3
            },
            {
              content: '定结县',

              levelNumber: 3
            },
            {
              content: '仲巴县',

              levelNumber: 3
            },
            {
              content: '亚东县',

              levelNumber: 3
            },
            {
              content: '吉隆县',

              levelNumber: 3
            },
            {
              content: '聂拉木县',

              levelNumber: 3
            },
            {
              content: '萨嘎县',

              levelNumber: 3
            },
            {
              content: '岗巴县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '昌都市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '卡若区',

              levelNumber: 3
            },
            {
              content: '江达县',

              levelNumber: 3
            },
            {
              content: '贡觉县',

              levelNumber: 3
            },
            {
              content: '类乌齐县',

              levelNumber: 3
            },
            {
              content: '丁青县',

              levelNumber: 3
            },
            {
              content: '察雅县',

              levelNumber: 3
            },
            {
              content: '八宿县',

              levelNumber: 3
            },
            {
              content: '左贡县',

              levelNumber: 3
            },
            {
              content: '芒康县',

              levelNumber: 3
            },
            {
              content: '洛隆县',

              levelNumber: 3
            },
            {
              content: '边坝县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '林芝市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '巴宜区',

              levelNumber: 3
            },
            {
              content: '工布江达县',

              levelNumber: 3
            },
            {
              content: '米林县',

              levelNumber: 3
            },
            {
              content: '墨脱县',

              levelNumber: 3
            },
            {
              content: '波密县',

              levelNumber: 3
            },
            {
              content: '察隅县',

              levelNumber: 3
            },
            { content: '朗县', levelNumber: 3 }
          ]
        },
        {
          content: '山南市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '乃东区',

              levelNumber: 3
            },
            {
              content: '扎囊县',

              levelNumber: 3
            },
            {
              content: '贡嘎县',

              levelNumber: 3
            },
            {
              content: '桑日县',

              levelNumber: 3
            },
            {
              content: '琼结县',

              levelNumber: 3
            },
            {
              content: '曲松县',

              levelNumber: 3
            },
            {
              content: '措美县',

              levelNumber: 3
            },
            {
              content: '洛扎县',

              levelNumber: 3
            },
            {
              content: '加查县',

              levelNumber: 3
            },
            {
              content: '隆子县',

              levelNumber: 3
            },
            {
              content: '错那县',

              levelNumber: 3
            },
            {
              content: '浪卡子县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '那曲市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '色尼区',

              levelNumber: 3
            },
            {
              content: '嘉黎县',

              levelNumber: 3
            },
            {
              content: '比如县',

              levelNumber: 3
            },
            {
              content: '聂荣县',

              levelNumber: 3
            },
            {
              content: '安多县',

              levelNumber: 3
            },
            {
              content: '申扎县',

              levelNumber: 3
            },
            {
              content: '索县',

              levelNumber: 3
            },
            {
              content: '班戈县',

              levelNumber: 3
            },
            {
              content: '巴青县',

              levelNumber: 3
            },
            {
              content: '尼玛县',

              levelNumber: 3
            },
            {
              content: '双湖县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阿里地区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '普兰县',

              levelNumber: 3
            },
            {
              content: '札达县',

              levelNumber: 3
            },
            {
              content: '噶尔县',

              levelNumber: 3
            },
            {
              content: '日土县',

              levelNumber: 3
            },
            {
              content: '革吉县',

              levelNumber: 3
            },
            {
              content: '改则县',

              levelNumber: 3
            },
            {
              content: '措勤县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '陕西省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '西安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '新城区',

              levelNumber: 3
            },
            {
              content: '碑林区',

              levelNumber: 3
            },
            {
              content: '莲湖区',

              levelNumber: 3
            },
            {
              content: '灞桥区',

              levelNumber: 3
            },
            {
              content: '未央区',

              levelNumber: 3
            },
            {
              content: '雁塔区',

              levelNumber: 3
            },
            {
              content: '阎良区',

              levelNumber: 3
            },
            {
              content: '临潼区',

              levelNumber: 3
            },
            {
              content: '长安区',

              levelNumber: 3
            },
            {
              content: '高陵区',

              levelNumber: 3
            },
            {
              content: '鄠邑区',

              levelNumber: 3
            },
            {
              content: '蓝田县',

              levelNumber: 3
            },
            {
              content: '周至县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '铜川市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '王益区',

              levelNumber: 3
            },
            {
              content: '印台区',

              levelNumber: 3
            },
            {
              content: '耀州区',

              levelNumber: 3
            },
            {
              content: '宜君县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '宝鸡市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '渭滨区',

              levelNumber: 3
            },
            {
              content: '金台区',

              levelNumber: 3
            },
            {
              content: '陈仓区',

              levelNumber: 3
            },
            {
              content: '凤翔区',

              levelNumber: 3
            },
            {
              content: '岐山县',

              levelNumber: 3
            },
            {
              content: '扶风县',

              levelNumber: 3
            },
            {
              content: '眉县',

              levelNumber: 3
            },
            {
              content: '陇县',

              levelNumber: 3
            },
            {
              content: '千阳县',

              levelNumber: 3
            },
            {
              content: '麟游县',

              levelNumber: 3
            },
            {
              content: '凤县',

              levelNumber: 3
            },
            {
              content: '太白县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '咸阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '秦都区',

              levelNumber: 3
            },
            {
              content: '杨陵区',

              levelNumber: 3
            },
            {
              content: '渭城区',

              levelNumber: 3
            },
            {
              content: '三原县',

              levelNumber: 3
            },
            {
              content: '泾阳县',

              levelNumber: 3
            },
            {
              content: '乾县',

              levelNumber: 3
            },
            {
              content: '礼泉县',

              levelNumber: 3
            },
            {
              content: '永寿县',

              levelNumber: 3
            },
            {
              content: '长武县',

              levelNumber: 3
            },
            {
              content: '旬邑县',

              levelNumber: 3
            },
            {
              content: '淳化县',

              levelNumber: 3
            },
            {
              content: '武功县',

              levelNumber: 3
            },
            {
              content: '兴平市',

              levelNumber: 3
            },
            {
              content: '彬州市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '渭南市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '临渭区',

              levelNumber: 3
            },
            {
              content: '华州区',

              levelNumber: 3
            },
            {
              content: '潼关县',

              levelNumber: 3
            },
            {
              content: '大荔县',

              levelNumber: 3
            },
            {
              content: '合阳县',

              levelNumber: 3
            },
            {
              content: '澄城县',

              levelNumber: 3
            },
            {
              content: '蒲城县',

              levelNumber: 3
            },
            {
              content: '白水县',

              levelNumber: 3
            },
            {
              content: '富平县',

              levelNumber: 3
            },
            {
              content: '韩城市',

              levelNumber: 3
            },
            {
              content: '华阴市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '延安市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '宝塔区',

              levelNumber: 3
            },
            {
              content: '安塞区',

              levelNumber: 3
            },
            {
              content: '延长县',

              levelNumber: 3
            },
            {
              content: '延川县',

              levelNumber: 3
            },
            {
              content: '志丹县',

              levelNumber: 3
            },
            {
              content: '吴起县',

              levelNumber: 3
            },
            {
              content: '甘泉县',

              levelNumber: 3
            },
            {
              content: '富县',

              levelNumber: 3
            },
            {
              content: '洛川县',

              levelNumber: 3
            },
            {
              content: '宜川县',

              levelNumber: 3
            },
            {
              content: '黄龙县',

              levelNumber: 3
            },
            {
              content: '黄陵县',

              levelNumber: 3
            },
            {
              content: '子长市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '汉中市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '汉台区',

              levelNumber: 3
            },
            {
              content: '南郑区',

              levelNumber: 3
            },
            {
              content: '城固县',

              levelNumber: 3
            },
            {
              content: '洋县',

              levelNumber: 3
            },
            {
              content: '西乡县',

              levelNumber: 3
            },
            {
              content: '勉县',

              levelNumber: 3
            },
            {
              content: '宁强县',

              levelNumber: 3
            },
            {
              content: '略阳县',

              levelNumber: 3
            },
            {
              content: '镇巴县',

              levelNumber: 3
            },
            {
              content: '留坝县',

              levelNumber: 3
            },
            {
              content: '佛坪县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '榆林市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '榆阳区',

              levelNumber: 3
            },
            {
              content: '横山区',

              levelNumber: 3
            },
            {
              content: '府谷县',

              levelNumber: 3
            },
            {
              content: '靖边县',

              levelNumber: 3
            },
            {
              content: '定边县',

              levelNumber: 3
            },
            {
              content: '绥德县',

              levelNumber: 3
            },
            {
              content: '米脂县',

              levelNumber: 3
            },
            {
              content: '佳县',

              levelNumber: 3
            },
            {
              content: '吴堡县',

              levelNumber: 3
            },
            {
              content: '清涧县',

              levelNumber: 3
            },
            {
              content: '子洲县',

              levelNumber: 3
            },
            {
              content: '神木市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '安康市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '汉滨区',

              levelNumber: 3
            },
            {
              content: '汉阴县',

              levelNumber: 3
            },
            {
              content: '石泉县',

              levelNumber: 3
            },
            {
              content: '宁陕县',

              levelNumber: 3
            },
            {
              content: '紫阳县',

              levelNumber: 3
            },
            {
              content: '岚皋县',

              levelNumber: 3
            },
            {
              content: '平利县',

              levelNumber: 3
            },
            {
              content: '镇坪县',

              levelNumber: 3
            },
            {
              content: '旬阳市',

              levelNumber: 3
            },
            {
              content: '白河县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '商洛市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '商州区',

              levelNumber: 3
            },
            {
              content: '洛南县',

              levelNumber: 3
            },
            {
              content: '丹凤县',

              levelNumber: 3
            },
            {
              content: '商南县',

              levelNumber: 3
            },
            {
              content: '山阳县',

              levelNumber: 3
            },
            {
              content: '镇安县',

              levelNumber: 3
            },
            {
              content: '柞水县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '甘肃省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '兰州市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城关区',

              levelNumber: 3
            },
            {
              content: '七里河区',

              levelNumber: 3
            },
            {
              content: '西固区',

              levelNumber: 3
            },
            {
              content: '安宁区',

              levelNumber: 3
            },
            {
              content: '红古区',

              levelNumber: 3
            },
            {
              content: '永登县',

              levelNumber: 3
            },
            {
              content: '皋兰县',

              levelNumber: 3
            },
            {
              content: '榆中县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '嘉峪关市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '峪泉镇',

              levelNumber: 3
            },
            {
              content: '新城镇',

              levelNumber: 3
            },
            {
              content: '文殊镇',

              levelNumber: 3
            },
            {
              content: '雄关街道',

              levelNumber: 3
            },
            {
              content: '钢城街道',

              levelNumber: 3
            }
          ]
        },
        {
          content: '金昌市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '金川区',

              levelNumber: 3
            },
            {
              content: '永昌县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '白银市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '白银区',

              levelNumber: 3
            },
            {
              content: '平川区',

              levelNumber: 3
            },
            {
              content: '靖远县',

              levelNumber: 3
            },
            {
              content: '会宁县',

              levelNumber: 3
            },
            {
              content: '景泰县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '天水市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '秦州区',

              levelNumber: 3
            },
            {
              content: '麦积区',

              levelNumber: 3
            },
            {
              content: '清水县',

              levelNumber: 3
            },
            {
              content: '秦安县',

              levelNumber: 3
            },
            {
              content: '甘谷县',

              levelNumber: 3
            },
            {
              content: '武山县',

              levelNumber: 3
            },
            {
              content: '张家川回族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '武威市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '凉州区',

              levelNumber: 3
            },
            {
              content: '民勤县',

              levelNumber: 3
            },
            {
              content: '古浪县',

              levelNumber: 3
            },
            {
              content: '天祝藏族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '张掖市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '甘州区',

              levelNumber: 3
            },
            {
              content: '肃南裕固族自治县',

              levelNumber: 3
            },
            {
              content: '民乐县',

              levelNumber: 3
            },
            {
              content: '临泽县',

              levelNumber: 3
            },
            {
              content: '高台县',

              levelNumber: 3
            },
            {
              content: '山丹县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '平凉市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '崆峒区',

              levelNumber: 3
            },
            {
              content: '泾川县',

              levelNumber: 3
            },
            {
              content: '灵台县',

              levelNumber: 3
            },
            {
              content: '崇信县',

              levelNumber: 3
            },
            {
              content: '庄浪县',

              levelNumber: 3
            },
            {
              content: '静宁县',

              levelNumber: 3
            },
            {
              content: '华亭市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '酒泉市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '肃州区',

              levelNumber: 3
            },
            {
              content: '金塔县',

              levelNumber: 3
            },
            {
              content: '瓜州县',

              levelNumber: 3
            },
            {
              content: '肃北蒙古族自治县',

              levelNumber: 3
            },
            {
              content: '阿克塞哈萨克族自治县',

              levelNumber: 3
            },
            {
              content: '玉门市',

              levelNumber: 3
            },
            {
              content: '敦煌市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '庆阳市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '西峰区',

              levelNumber: 3
            },
            {
              content: '庆城县',

              levelNumber: 3
            },
            {
              content: '环县',

              levelNumber: 3
            },
            {
              content: '华池县',

              levelNumber: 3
            },
            {
              content: '合水县',

              levelNumber: 3
            },
            {
              content: '正宁县',

              levelNumber: 3
            },
            {
              content: '宁县',

              levelNumber: 3
            },
            {
              content: '镇原县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '定西市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '安定区',

              levelNumber: 3
            },
            {
              content: '通渭县',

              levelNumber: 3
            },
            {
              content: '陇西县',

              levelNumber: 3
            },
            {
              content: '渭源县',

              levelNumber: 3
            },
            {
              content: '临洮县',

              levelNumber: 3
            },
            {
              content: '漳县',

              levelNumber: 3
            },
            { content: '岷县', levelNumber: 3 }
          ]
        },
        {
          content: '陇南市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '武都区',

              levelNumber: 3
            },
            {
              content: '成县',

              levelNumber: 3
            },
            {
              content: '文县',

              levelNumber: 3
            },
            {
              content: '宕昌县',

              levelNumber: 3
            },
            {
              content: '康县',

              levelNumber: 3
            },
            {
              content: '西和县',

              levelNumber: 3
            },
            {
              content: '礼县',

              levelNumber: 3
            },
            {
              content: '徽县',

              levelNumber: 3
            },
            {
              content: '两当县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '临夏回族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '临夏市',

              levelNumber: 3
            },
            {
              content: '临夏县',

              levelNumber: 3
            },
            {
              content: '康乐县',

              levelNumber: 3
            },
            {
              content: '永靖县',

              levelNumber: 3
            },
            {
              content: '广河县',

              levelNumber: 3
            },
            {
              content: '和政县',

              levelNumber: 3
            },
            {
              content: '东乡族自治县',

              levelNumber: 3
            },
            {
              content: '积石山保安族东乡族撒拉族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '甘南藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '合作市',

              levelNumber: 3
            },
            {
              content: '临潭县',

              levelNumber: 3
            },
            {
              content: '卓尼县',

              levelNumber: 3
            },
            {
              content: '舟曲县',

              levelNumber: 3
            },
            {
              content: '迭部县',

              levelNumber: 3
            },
            {
              content: '玛曲县',

              levelNumber: 3
            },
            {
              content: '碌曲县',

              levelNumber: 3
            },
            {
              content: '夏河县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '青海省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '西宁市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '城东区',

              levelNumber: 3
            },
            {
              content: '城中区',

              levelNumber: 3
            },
            {
              content: '城西区',

              levelNumber: 3
            },
            {
              content: '城北区',

              levelNumber: 3
            },
            {
              content: '湟中区',

              levelNumber: 3
            },
            {
              content: '大通回族土族自治县',

              levelNumber: 3
            },
            {
              content: '湟源县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '海东市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '乐都区',

              levelNumber: 3
            },
            {
              content: '平安区',

              levelNumber: 3
            },
            {
              content: '民和回族土族自治县',

              levelNumber: 3
            },
            {
              content: '互助土族自治县',

              levelNumber: 3
            },
            {
              content: '化隆回族自治县',

              levelNumber: 3
            },
            {
              content: '循化撒拉族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '海北藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '门源回族自治县',

              levelNumber: 3
            },
            {
              content: '祁连县',

              levelNumber: 3
            },
            {
              content: '海晏县',

              levelNumber: 3
            },
            {
              content: '刚察县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '黄南藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '同仁市',

              levelNumber: 3
            },
            {
              content: '尖扎县',

              levelNumber: 3
            },
            {
              content: '泽库县',

              levelNumber: 3
            },
            {
              content: '河南蒙古族自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '海南藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '共和县',

              levelNumber: 3
            },
            {
              content: '同德县',

              levelNumber: 3
            },
            {
              content: '贵德县',

              levelNumber: 3
            },
            {
              content: '兴海县',

              levelNumber: 3
            },
            {
              content: '贵南县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '果洛藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '玛沁县',

              levelNumber: 3
            },
            {
              content: '班玛县',

              levelNumber: 3
            },
            {
              content: '甘德县',

              levelNumber: 3
            },
            {
              content: '达日县',

              levelNumber: 3
            },
            {
              content: '久治县',

              levelNumber: 3
            },
            {
              content: '玛多县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '玉树藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '玉树市',

              levelNumber: 3
            },
            {
              content: '杂多县',

              levelNumber: 3
            },
            {
              content: '称多县',

              levelNumber: 3
            },
            {
              content: '治多县',

              levelNumber: 3
            },
            {
              content: '囊谦县',

              levelNumber: 3
            },
            {
              content: '曲麻莱县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '海西蒙古族藏族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '格尔木市',

              levelNumber: 3
            },
            {
              content: '德令哈市',

              levelNumber: 3
            },
            {
              content: '茫崖市',

              levelNumber: 3
            },
            {
              content: '乌兰县',

              levelNumber: 3
            },
            {
              content: '都兰县',

              levelNumber: 3
            },
            {
              content: '天峻县',

              levelNumber: 3
            },
            {
              content: '海西蒙古族藏族自治州直辖',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '宁夏回族自治区',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '银川市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '兴庆区',

              levelNumber: 3
            },
            {
              content: '西夏区',

              levelNumber: 3
            },
            {
              content: '金凤区',

              levelNumber: 3
            },
            {
              content: '永宁县',

              levelNumber: 3
            },
            {
              content: '贺兰县',

              levelNumber: 3
            },
            {
              content: '灵武市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '石嘴山市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '大武口区',

              levelNumber: 3
            },
            {
              content: '惠农区',

              levelNumber: 3
            },
            {
              content: '平罗县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '吴忠市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '利通区',

              levelNumber: 3
            },
            {
              content: '红寺堡区',

              levelNumber: 3
            },
            {
              content: '盐池县',

              levelNumber: 3
            },
            {
              content: '同心县',

              levelNumber: 3
            },
            {
              content: '青铜峡市',

              levelNumber: 3
            }
          ]
        },
        {
          content: '固原市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '原州区',

              levelNumber: 3
            },
            {
              content: '西吉县',

              levelNumber: 3
            },
            {
              content: '隆德县',

              levelNumber: 3
            },
            {
              content: '泾源县',

              levelNumber: 3
            },
            {
              content: '彭阳县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '中卫市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '沙坡头区',

              levelNumber: 3
            },
            {
              content: '中宁县',

              levelNumber: 3
            },
            {
              content: '海原县',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '新疆维吾尔自治区',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '乌鲁木齐市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '天山区',

              levelNumber: 3
            },
            {
              content: '沙依巴克区',

              levelNumber: 3
            },
            {
              content: '新市区',

              levelNumber: 3
            },
            {
              content: '水磨沟区',

              levelNumber: 3
            },
            {
              content: '头屯河区',

              levelNumber: 3
            },
            {
              content: '达坂城区',

              levelNumber: 3
            },
            {
              content: '米东区',

              levelNumber: 3
            },
            {
              content: '乌鲁木齐县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '克拉玛依市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '独山子区',

              levelNumber: 3
            },
            {
              content: '克拉玛依区',

              levelNumber: 3
            },
            {
              content: '白碱滩区',

              levelNumber: 3
            },
            {
              content: '乌尔禾区',

              levelNumber: 3
            }
          ]
        },
        {
          content: '吐鲁番市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '高昌区',

              levelNumber: 3
            },
            {
              content: '鄯善县',

              levelNumber: 3
            },
            {
              content: '托克逊县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '哈密市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '伊州区',

              levelNumber: 3
            },
            {
              content: '巴里坤哈萨克自治县',

              levelNumber: 3
            },
            {
              content: '伊吾县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '昌吉回族自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '昌吉市',

              levelNumber: 3
            },
            {
              content: '阜康市',

              levelNumber: 3
            },
            {
              content: '呼图壁县',

              levelNumber: 3
            },
            {
              content: '玛纳斯县',

              levelNumber: 3
            },
            {
              content: '奇台县',

              levelNumber: 3
            },
            {
              content: '吉木萨尔县',

              levelNumber: 3
            },
            {
              content: '木垒哈萨克自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '博尔塔拉蒙古自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '博乐市',

              levelNumber: 3
            },
            {
              content: '阿拉山口市',

              levelNumber: 3
            },
            {
              content: '精河县',

              levelNumber: 3
            },
            {
              content: '温泉县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '巴音郭楞蒙古自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '库尔勒市',

              levelNumber: 3
            },
            {
              content: '轮台县',

              levelNumber: 3
            },
            {
              content: '尉犁县',

              levelNumber: 3
            },
            {
              content: '若羌县',

              levelNumber: 3
            },
            {
              content: '且末县',

              levelNumber: 3
            },
            {
              content: '焉耆回族自治县',

              levelNumber: 3
            },
            {
              content: '和静县',

              levelNumber: 3
            },
            {
              content: '和硕县',

              levelNumber: 3
            },
            {
              content: '博湖县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阿克苏地区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '阿克苏市',

              levelNumber: 3
            },
            {
              content: '库车市',

              levelNumber: 3
            },
            {
              content: '温宿县',

              levelNumber: 3
            },
            {
              content: '沙雅县',

              levelNumber: 3
            },
            {
              content: '新和县',

              levelNumber: 3
            },
            {
              content: '拜城县',

              levelNumber: 3
            },
            {
              content: '乌什县',

              levelNumber: 3
            },
            {
              content: '阿瓦提县',

              levelNumber: 3
            },
            {
              content: '柯坪县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '克孜勒苏柯尔克孜自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '阿图什市',

              levelNumber: 3
            },
            {
              content: '阿克陶县',

              levelNumber: 3
            },
            {
              content: '阿合奇县',

              levelNumber: 3
            },
            {
              content: '乌恰县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '喀什地区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '喀什市',

              levelNumber: 3
            },
            {
              content: '疏附县',

              levelNumber: 3
            },
            {
              content: '疏勒县',

              levelNumber: 3
            },
            {
              content: '英吉沙县',

              levelNumber: 3
            },
            {
              content: '泽普县',

              levelNumber: 3
            },
            {
              content: '莎车县',

              levelNumber: 3
            },
            {
              content: '叶城县',

              levelNumber: 3
            },
            {
              content: '麦盖提县',

              levelNumber: 3
            },
            {
              content: '岳普湖县',

              levelNumber: 3
            },
            {
              content: '伽师县',

              levelNumber: 3
            },
            {
              content: '巴楚县',

              levelNumber: 3
            },
            {
              content: '塔什库尔干塔吉克自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '和田地区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '和田市',

              levelNumber: 3
            },
            {
              content: '和田县',

              levelNumber: 3
            },
            {
              content: '墨玉县',

              levelNumber: 3
            },
            {
              content: '皮山县',

              levelNumber: 3
            },
            {
              content: '洛浦县',

              levelNumber: 3
            },
            {
              content: '策勒县',

              levelNumber: 3
            },
            {
              content: '于田县',

              levelNumber: 3
            },
            {
              content: '民丰县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '伊犁哈萨克自治州',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '伊宁市',

              levelNumber: 3
            },
            {
              content: '奎屯市',

              levelNumber: 3
            },
            {
              content: '霍尔果斯市',

              levelNumber: 3
            },
            {
              content: '伊宁县',

              levelNumber: 3
            },
            {
              content: '察布查尔锡伯自治县',

              levelNumber: 3
            },
            {
              content: '霍城县',

              levelNumber: 3
            },
            {
              content: '巩留县',

              levelNumber: 3
            },
            {
              content: '新源县',

              levelNumber: 3
            },
            {
              content: '昭苏县',

              levelNumber: 3
            },
            {
              content: '特克斯县',

              levelNumber: 3
            },
            {
              content: '尼勒克县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '塔城地区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '塔城市',

              levelNumber: 3
            },
            {
              content: '乌苏市',

              levelNumber: 3
            },
            {
              content: '额敏县',

              levelNumber: 3
            },
            {
              content: '沙湾市',

              levelNumber: 3
            },
            {
              content: '托里县',

              levelNumber: 3
            },
            {
              content: '裕民县',

              levelNumber: 3
            },
            {
              content: '和布克赛尔蒙古自治县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阿勒泰地区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '阿勒泰市',

              levelNumber: 3
            },
            {
              content: '布尔津县',

              levelNumber: 3
            },
            {
              content: '富蕴县',

              levelNumber: 3
            },
            {
              content: '福海县',

              levelNumber: 3
            },
            {
              content: '哈巴河县',

              levelNumber: 3
            },
            {
              content: '青河县',

              levelNumber: 3
            },
            {
              content: '吉木乃县',

              levelNumber: 3
            }
          ]
        },
        {
          content: '石河子市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '向阳街道',

              levelNumber: 3
            },
            {
              content: '红山街道',

              levelNumber: 3
            },
            {
              content: '兵团一五二团',

              levelNumber: 3
            },
            {
              content: '东城街道',

              levelNumber: 3
            },
            {
              content: '石河子镇',

              levelNumber: 3
            },
            {
              content: '老街街道',

              levelNumber: 3
            },
            {
              content: '北泉镇',

              levelNumber: 3
            },
            {
              content: '新城街道',

              levelNumber: 3
            }
          ]
        },
        {
          content: '阿拉尔市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '幸福路街道',

              levelNumber: 3
            },
            {
              content: '阿拉尔农场',

              levelNumber: 3
            },
            {
              content: '兵团第一师幸福农场',

              levelNumber: 3
            },
            {
              content: '工业园区',

              levelNumber: 3
            },
            {
              content: '玛滩镇',

              levelNumber: 3
            },
            {
              content: '花桥镇',

              levelNumber: 3
            },
            {
              content: '兵团第一师水利水电工程处',

              levelNumber: 3
            },
            {
              content: '托喀依乡',

              levelNumber: 3
            },
            {
              content: '青松路街道',

              levelNumber: 3
            },
            {
              content: '塔门镇',

              levelNumber: 3
            },
            {
              content: '中心监狱',

              levelNumber: 3
            },
            {
              content: '兵团第一师塔里木灌区水利管理处',

              levelNumber: 3
            },
            {
              content: '金杨镇',

              levelNumber: 3
            },
            {
              content: '昌安镇',

              levelNumber: 3
            },
            {
              content: '金银川路街道',

              levelNumber: 3
            },
            {
              content: '塔南镇',

              levelNumber: 3
            },
            {
              content: '新开岭镇',

              levelNumber: 3
            },
            {
              content: '幸福镇',

              levelNumber: 3
            },
            {
              content: '南口街道',

              levelNumber: 3
            }
          ]
        },
        {
          content: '图木舒克市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '海安镇',

              levelNumber: 3
            },
            {
              content: '兵团图木舒克市永安坝',

              levelNumber: 3
            },
            {
              content: '唐驿镇',

              levelNumber: 3
            },
            {
              content: '前海街道',

              levelNumber: 3
            },
            {
              content: '兵团图木舒克市喀拉拜勒镇',

              levelNumber: 3
            },
            {
              content: '永安坝街道',

              levelNumber: 3
            },
            {
              content: '齐干却勒街道',

              levelNumber: 3
            },
            {
              content: '金胡杨镇',

              levelNumber: 3
            },
            {
              content: '夏河镇',

              levelNumber: 3
            },
            {
              content: '永安镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '五家渠市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '军垦路街道',

              levelNumber: 3
            },
            {
              content: '梧桐镇',

              levelNumber: 3
            },
            {
              content: '人民路街道',

              levelNumber: 3
            },
            {
              content: '兵团一零一团',

              levelNumber: 3
            },
            {
              content: '蔡家湖镇',

              levelNumber: 3
            },
            {
              content: '青湖路街道',

              levelNumber: 3
            }
          ]
        },
        {
          content: '北屯市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '北屯镇',

              levelNumber: 3
            },
            {
              content: '丰庆镇',

              levelNumber: 3
            },
            {
              content: '双渠镇',

              levelNumber: 3
            },
            {
              content: '海川镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '铁门关市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '博古其镇',

              levelNumber: 3
            },
            {
              content: '双丰镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '双河市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '兵团八十九团',

              levelNumber: 3
            },
            {
              content: '石峪镇',

              levelNumber: 3
            },
            {
              content: '博河镇',

              levelNumber: 3
            },
            {
              content: '双乐镇',

              levelNumber: 3
            },
            {
              content: '双桥镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '可克达拉市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '长丰镇',

              levelNumber: 3
            },
            {
              content: '都拉塔口岸',

              levelNumber: 3
            },
            {
              content: '金粱镇',

              levelNumber: 3
            },
            {
              content: '榆树庄镇',

              levelNumber: 3
            },
            {
              content: '苇湖镇',

              levelNumber: 3
            },
            {
              content: '金屯镇',

              levelNumber: 3
            }
          ]
        },
        {
          content: '昆玉市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '普恰克其乡',

              levelNumber: 3
            },
            {
              content: '博斯坦乡',

              levelNumber: 3
            },
            {
              content: '兵团二二四团',

              levelNumber: 3
            },
            {
              content: '老兵镇',

              levelNumber: 3
            },
            {
              content: '奴尔乡',

              levelNumber: 3
            },
            {
              content: '喀拉喀什镇',

              levelNumber: 3
            },
            {
              content: '昆牧镇',

              levelNumber: 3
            },
            {
              content: '乌尔其乡',

              levelNumber: 3
            },
            {
              content: '昆泉镇',

              levelNumber: 3
            },
            {
              content: '乌鲁克萨依乡',

              levelNumber: 3
            },
            {
              content: '阔依其乡',

              levelNumber: 3
            }
          ]
        },
        {
          content: '胡杨河市',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '兵团一三零团',

              levelNumber: 3
            },
            {
              content: '五五新镇街道',

              levelNumber: 3
            },
            {
              content: '兵团一二八团',

              levelNumber: 3
            },
            {
              content: '兵团一二九团',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '台湾省',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '台湾省',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '台湾省',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '香港特别行政区',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '香港特别行政区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '中西区',

              levelNumber: 3
            },
            {
              content: '湾仔区',

              levelNumber: 3
            },
            {
              content: '东区',

              levelNumber: 3
            },
            {
              content: '南区',

              levelNumber: 3
            },
            {
              content: '油尖旺区',

              levelNumber: 3
            },
            {
              content: '深水埗区',

              levelNumber: 3
            },
            {
              content: '九龙城区',

              levelNumber: 3
            },
            {
              content: '黄大仙区',

              levelNumber: 3
            },
            {
              content: '观塘区',

              levelNumber: 3
            },
            {
              content: '荃湾区',

              levelNumber: 3
            },
            {
              content: '屯门区',

              levelNumber: 3
            },
            {
              content: '元朗区',

              levelNumber: 3
            },
            {
              content: '北区',

              levelNumber: 3
            },
            {
              content: '大埔区',

              levelNumber: 3
            },
            {
              content: '西贡区',

              levelNumber: 3
            },
            {
              content: '沙田区',

              levelNumber: 3
            },
            {
              content: '葵青区',

              levelNumber: 3
            },
            {
              content: '离岛区',

              levelNumber: 3
            }
          ]
        }
      ]
    },
    {
      content: '澳门特别行政区',

      levelNumber: 1,
      nextLevelOptions: [
        {
          content: '澳门特别行政区',

          levelNumber: 2,
          nextLevelOptions: [
            {
              content: '花地玛堂区',

              levelNumber: 3
            },
            {
              content: '花王堂区',

              levelNumber: 3
            },
            {
              content: '望德堂区',

              levelNumber: 3
            },
            {
              content: '大堂区',

              levelNumber: 3
            },
            {
              content: '风顺堂区',

              levelNumber: 3
            },
            {
              content: '嘉模堂区',

              levelNumber: 3
            },
            {
              content: '路凼填海区',

              levelNumber: 3
            },
            {
              content: '圣方济各堂区',

              levelNumber: 3
            }
          ]
        }
      ]
    }
  ]
}
